<template>
  <div class="renderPage datatable-overflow" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <v-toolbar flat :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="px-4 border-bottom-light pos-toolbar-theme">
      <v-avatar tile size="40" class="mr-3">
        <v-icon color="primary" size="32">mdi-monitor-dashboard</v-icon>
      </v-avatar>
      <v-toolbar-title class="font-weight-black primary--text text-h6 text-uppercase letter-spacing-1">
        Eduva POS <span class="font-weight-light grey--text">| Terminal de Venta</span>
      </v-toolbar-title>
      <v-spacer />
      <div v-if="mostrarSelectorTipoDoc" class="d-flex align-center mr-4">
        <v-icon small :color="forzarFactura ? 'primary' : 'grey'" class="mr-1">
          {{ forzarFactura ? 'mdi-file-document-check-outline' : 'mdi-receipt-outline' }}
        </v-icon>
        <span class="caption grey--text mr-2">{{ forzarFactura ? 'Factura Electrónica' : 'Tiquete Electrónico' }}</span>
        <v-switch
          v-model="forzarFactura"
          color="primary"
          hide-details
          dense
          inset
          class="mt-0 pt-0 tipo-doc-switch"
          @change="getCodigoSegunCliente"
        ></v-switch>
      </div>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" class="rounded-lg mx-1" depressed @click="mostrarBuscarArticulos">
            <v-icon>mdi-cart-plus</v-icon>
          </v-btn>
        </template>
        <span>Buscar Artículo (F2)</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" class="rounded-lg mx-1" depressed @click="mostrarBuscarClientes">
            <v-icon>mdi-account-search</v-icon>
          </v-btn>
        </template>
        <span>Buscar Cliente (F4)</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" class="rounded-lg mx-1" depressed @click="abrirNuevoCliente">
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <span>Nuevo Cliente</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" class="rounded-lg mx-1" depressed @click="mostrarCajaMov">
            <v-icon>mdi-cash-register</v-icon>
          </v-btn>
        </template>
        <span>Caja</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" class="rounded-lg mx-1" depressed @click="mostrarInformacionAdicional">
            <v-icon>mdi-settings-outline</v-icon>
          </v-btn>
        </template>
        <span>Opciones</span>
      </v-tooltip>

      <v-divider vertical class="mx-3" />

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="error" class="rounded-lg mx-1" depressed @click="cerrarCajaPOS()">
            <v-icon>mdi-minus-circle</v-icon>
          </v-btn>
        </template>
        <span>Cerrar Caja</span>
      </v-tooltip>
    </v-toolbar>

    <CashOpening v-if="!cashOpened" :user="user.nombre" @open-cash="onOpenCash" />

    <v-row v-if="cashOpened" no-gutters class="pos-split-container mx-0">
      <!-- PANEL IZQUIERDO: CARRITO Y BÚSQUEDA -->
      <v-col cols="12" md="8" class="pos-cart-panel px-2 py-4">
        <v-container fluid class="pa-0">
          <v-row class="mb-2" align="center" no-gutters>
            <v-col cols="6" class="pr-2">
              <v-text-field
                v-model="codigoBarras"
                placeholder="Escanea o escribe código..."
                prepend-inner-icon="mdi-barcode-scan"
                class="scan-input"
                solo flat hide-details
                rounded-lg
                @keyup.enter.native="onEnter"
                ref="barrasFocus"
                @change="changeValueComponent"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="editedItem.clienteNombre"
                placeholder="Nombre del Cliente"
                prepend-inner-icon="mdi-account-outline"
                class="scan-input"
                solo flat hide-details
                readonly
                rounded-lg
                @click="mostrarBuscarClientes"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col cols="12">
              <!-- CART TABLE -->
              <v-card class="premium-card overflow-hidden">


        <!-- MODERN DATA TABLE -->
        <v-data-table 
          hide-default-footer 
          :headers="headersDetalle" 
          :items="lineasDetalle" 
          :search="search"
          :items-per-page="-1" 
          class="cart-table elevation-0" 
          fixed-header 
        >
          <template v-slot:[`item.cantidad`]="{ item }">
            <span>{{ item.cantidad }}</span>
          </template>

          <template v-slot:[`item.montoStr`]="{ item }">
            <span>{{ item.montoStr }}</span>
          </template>

          <template v-slot:[`item.totalLineaStr`]="{ item }">
            <span>{{ item.totalLineaStr }}</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn color="primary" depressed dark class="rounded-lg mx-1" style="min-width: 36px; height: 36px; padding: 0" @click="detalleEditItem(item)">
              <v-icon size="20">mdi-pencil</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.delete`]="{ item }">
            <v-btn color="error" depressed dark class="rounded-lg mx-1" style="min-width: 36px; height: 36px; padding: 0" @click="deleteItem(item)">
              <v-icon size="20">mdi-trash-can</v-icon>
            </v-btn>
          </template>
        </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>

      <v-col cols="12" md="4" class="pos-checkout-panel px-2 py-4">
        <div class="total-display pb-3 elevation-4" :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'">
          <div class="total-label text-center font-weight-black text-uppercase opacity-90 letter-spacing-1">TOTAL A PAGAR</div>
          <div class="total-amount text-center">{{ editedItem.totalComprobanteStr || '0.00' }}</div>
          
          <v-divider class="my-2 opacity-20" :dark="!$vuetify.theme.dark"></v-divider>
          
          <div class="d-flex justify-space-between font-weight-bold sub-amounts">
            <span class="opacity-90">Subtotal</span>
            <span>{{ editedItem.subtotalStr || '0.00' }}</span>
          </div>
          <div class="d-flex justify-space-between font-weight-bold sub-amounts">
            <span class="opacity-90">Impuestos</span>
            <span>{{ editedItem.totalImpuestoStr || '0.00' }}</span>
          </div>
        </div>

        <div class="panel-bottom-actions pa-3 mt-2 actions-container">

          <!-- QUICK INFO ROW -->
          <div class="d-flex justify-space-between align-center mb-2 px-1">
            <v-chip color="primary" outlined class="font-weight-bold" style="font-size: 0.8rem !important; height: 26px;">
              <v-icon left size="16" :color="$vuetify.theme.dark ? 'white' : 'black'">mdi-cart-outline</v-icon>
              <span :style="$vuetify.theme.dark ? 'color: white !important;' : 'color: black !important;'">{{ lineasDetalle.reduce((a, b) => a + (b.cantidad || 1), 0) }} Art.</span>
            </v-chip>
            <v-chip :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'" :text-color="$vuetify.theme.dark ? 'white' : 'grey darken-3'" class="font-weight-medium" style="border: none !important; font-size: 0.75rem !important; height: 26px;">
               Term: <strong class="ml-1">{{ editedItem.terminal || '...' }}</strong>
            </v-chip>
          </div>

          <!-- QUICK CASH BUTTONS -->
          <div>
            <div class="text-caption grey--text text-uppercase font-weight-bold mb-2 ml-1 letter-spacing-1" style="font-size: 0.70rem !important">Monto Rápido</div>
            <div class="d-flex flex-wrap justify-space-between">
               <v-btn outlined color="primary" class="flex-grow-1 rounded-lg mx-0 quick-cash-btn" @click="mostrarVentanaCobro(5000)">
                 <v-icon left size="18">mdi-cash</v-icon>
                 <span class="font-weight-bold" style="font-size: 0.95rem !important;">₡5.000</span>
               </v-btn>
               <v-btn outlined color="primary" class="flex-grow-1 rounded-lg mx-2 quick-cash-btn" @click="mostrarVentanaCobro(10000)">
                 <v-icon left size="18">mdi-cash</v-icon>
                 <span class="font-weight-bold" style="font-size: 0.95rem !important;">₡10.000</span>
               </v-btn>
               <v-btn outlined color="primary" class="flex-grow-1 rounded-lg mx-0 quick-cash-btn" @click="mostrarVentanaCobro(20000)">
                 <v-icon left size="18">mdi-cash</v-icon>
                 <span class="font-weight-bold" style="font-size: 0.95rem !important;">₡20.000</span>
               </v-btn>
            </div>
          </div>

          <!-- BOTONES DE ACCIÓN -->
          <div>
            <v-btn color="success" class="rounded-xl elevation-3 mb-3 pos-btn-pago" block dark x-large depressed @click="mostrarVentanaCobro()">
              <v-icon left>mdi-cash-multiple</v-icon>
              <span class="font-weight-black letter-spacing-1 text-uppercase">PAGO (F8)</span>
            </v-btn>
            <v-btn color="warning" class="rounded-xl elevation-2 pos-btn-nueva" block dark x-large depressed @click="cancelarVenta()">
              <v-icon left size="22">mdi-file-plus-outline</v-icon>
              <span class="font-weight-bold text-uppercase">NUEVA VENTA (F9)</span>
            </v-btn>
          </div>
        </div>
      </v-col>

      <!-- DIALOGS -->
      <v-dialog v-model="dialogArticuloError" max-width="400px" overlay-opacity="0.8">
        <v-card class="rounded-xl pa-4 text-center" :dark="$vuetify.theme.dark">
          <v-icon color="error" size="64" class="mb-4">mdi-alert-circle-outline</v-icon>
          <h3 class="text-h5 font-weight-bold mb-2">Artículo no encontrado</h3>
          <p class="grey--text">No existe ningún articulo con ese código de barras.</p>
          <v-btn color="primary" rounded block x-large depressed @click="dialogArticuloError = false">Entendido</v-btn>
        </v-card>
      </v-dialog>

      <!-- DELETE LINE DIALOG -->
      <v-dialog v-model="dialogDelete" max-width="380px" overlay-opacity="0.8">
        <v-card class="rounded-xl pa-4 text-center" :dark="$vuetify.theme.dark">
          <v-icon color="error" size="56" class="mb-3">mdi-trash-can-outline</v-icon>
          <h3 class="text-h6 font-weight-bold mb-1">¿Eliminar línea?</h3>
          <p class="grey--text mb-4">{{ detalleEditedItem.descripcion }}</p>
          <v-row no-gutters>
            <v-col cols="6" class="pr-1">
              <v-btn color="grey lighten-2" rounded block depressed @click="dialogDelete = false">Cancelar</v-btn>
            </v-col>
            <v-col cols="6" class="pl-1">
              <v-btn color="error" rounded block depressed dark @click="deleteItemConfirm">Eliminar</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- ADD/EDIT ARTICLE DIALOG -->
      <v-dialog v-model="dialogArticulos" max-width="500px" persistent>
        <v-card flat class="overflow-hidden" style="border-radius:4px" :dark="$vuetify.theme.dark">
          <v-toolbar flat height="56" style="background-color:#37474f !important" dark>
            <v-icon class="mr-2">mdi-cart-plus</v-icon>
            <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem">Configurar Artículo</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-6">
             <div class="mb-6">
               <div class="text-h6 font-weight-bold" :class="$vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-4'">{{ detalleEditedItem.descripcion }}</div>
               <div class="caption grey--text">Código: {{ detalleEditedItem.articulo }}</div>
             </div>
             
             <v-row dense>
               <v-col cols="12" v-if="articulo.esGenerico">
                 <v-text-field
                   v-model="detalleEditedItem.descripcion"
                   label="Descripción"
                   outlined rounded-lg dense
                   prepend-inner-icon="mdi-format-text"
                   autofocus
                 ></v-text-field>
               </v-col>
               <v-col cols="12" md="6">
                 <v-text-field
                   v-model="detalleEditedItem.cantidad"
                   label="Cantidad"
                   type="number"
                   outlined rounded-lg dense
                   prepend-inner-icon="mdi-plus-minus-variant"
                   :autofocus="!articulo.esGenerico"
                    @focus="$event.target.select()"
                 ></v-text-field>
               </v-col>
               <v-col cols="12" md="6">
                 <v-text-field 
                   v-model="detalleEditedItem.monto" 
                   label="Precio" 
                   type="number" 
                   outlined rounded-lg dense 
                   prefix="₡"
                    @focus="$event.target.select()"
                 ></v-text-field>
               </v-col>
               <v-col cols="12">
                 <v-text-field 
                   v-model="detalleEditedItem.porcDescuento" 
                   label="% Descuento" 
                   type="number" 
                   outlined rounded-lg dense 
                   suffix="%"
                    @focus="$event.target.select()"
                 ></v-text-field>
               </v-col>
             </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4 d-flex">
            <v-btn text class="font-weight-bold" style="border-radius:4px" @click="close">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn style="background-color:#37474f !important;border-radius:4px" dark depressed class="px-8 font-weight-bold" @click="saveDetalleArticulo">
              <v-icon left>mdi-cart-plus</v-icon> Agregar al Carrito
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogCobrar" max-width="640px" persistent custom-class="payment-dialog">
        <v-card class="payment-dialog-card" :dark="$vuetify.theme.dark">
          <!-- HEADER CON TOTAL -->
          <div class="payment-header white--text" style="background-color:#37474f !important;">
            <div class="d-flex justify-space-between align-center mb-4">
              <span class="text-h6 font-weight-bold">Finalizar Venta</span>
              <v-btn icon dark @click="cancelarCobro"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="text-center">
              <div class="caption opacity-80 text-uppercase letter-spacing-1">Monto Total</div>
              <div class="text-h3 font-weight-black">₡{{ editedItem.totalComprobante }}</div>
              <v-chip v-if="cajaPOS && cajaPOS.tdc > 0" label small color="rgba(255,255,255,0.2)" class="mt-1 font-weight-bold white--text">
                Equivalente: ${{ totalEnDolares }} (TC: ₡{{ cajaPOS.tdc }})
              </v-chip>
            </div>
          </div>

          <v-card-text class="pa-5">

            <!-- TABLA DE MÉTODOS DE PAGO MIXTO -->
            <div class="mb-3">
              <div class="text-caption font-weight-bold text-uppercase mb-3 grey--text letter-spacing-1">
                Distribuir pago por método
              </div>

              <v-card outlined class="rounded-xl overflow-hidden" :class="$vuetify.theme.dark ? 'grey darken-4' : ''">
                <!-- Efectivo -->
                <div class="payment-method-row d-flex align-center px-4 py-2" :class="pagosMixtos.efectivo > 0 ? ($vuetify.theme.dark ? 'teal darken-4' : 'teal lighten-5') : ''">
                  <v-icon :color="pagosMixtos.efectivo > 0 ? 'teal' : 'grey'" class="mr-3" size="22">mdi-cash</v-icon>
                  <span class="font-weight-bold text-body-2 mr-auto" style="min-width:110px">Efectivo</span>
                  <v-text-field
                    v-model.number="pagosMixtos.efectivo"
                    type="number" min="0" dense outlined hide-details
                    prefix="₡" class="payment-amount-field" style="max-width:160px"
                    @input="onPagoMixtoChange" @focus="$event.target.select()"
                  ></v-text-field>
                </div>
                <v-divider></v-divider>

                <!-- Tarjeta -->
                <div class="payment-method-row d-flex align-center px-4 py-2" :class="pagosMixtos.tarjeta > 0 ? ($vuetify.theme.dark ? 'blue darken-4' : 'blue lighten-5') : ''">
                  <v-icon :color="pagosMixtos.tarjeta > 0 ? 'blue' : 'grey'" class="mr-3" size="22">mdi-credit-card</v-icon>
                  <span class="font-weight-bold text-body-2 mr-auto" style="min-width:110px">Tarjeta</span>
                  <v-text-field
                    v-model.number="pagosMixtos.tarjeta"
                    type="number" min="0" dense outlined hide-details
                    prefix="₡" class="payment-amount-field" style="max-width:160px"
                    @input="onPagoMixtoChange" @focus="$event.target.select()"
                  ></v-text-field>
                </div>
                <v-divider></v-divider>

                <!-- SINPE -->
                <div class="payment-method-row d-flex align-center px-4 py-2" :class="pagosMixtos.sinpe > 0 ? ($vuetify.theme.dark ? 'purple darken-4' : 'purple lighten-5') : ''">
                  <v-icon :color="pagosMixtos.sinpe > 0 ? 'purple' : 'grey'" class="mr-3" size="22">mdi-cellphone</v-icon>
                  <span class="font-weight-bold text-body-2 mr-auto" style="min-width:110px">SINPE</span>
                  <v-text-field
                    v-model.number="pagosMixtos.sinpe"
                    type="number" min="0" dense outlined hide-details
                    prefix="₡" class="payment-amount-field" style="max-width:160px"
                    @input="onPagoMixtoChange" @focus="$event.target.select()"
                  ></v-text-field>
                </div>
                <v-divider></v-divider>

                <!-- Transferencia/Depósito -->
                <div class="payment-method-row d-flex align-center px-4 py-2" :class="pagosMixtos.transDepo > 0 ? ($vuetify.theme.dark ? 'orange darken-4' : 'orange lighten-5') : ''">
                  <v-icon :color="pagosMixtos.transDepo > 0 ? 'orange darken-1' : 'grey'" class="mr-3" size="22">mdi-bank-transfer</v-icon>
                  <span class="font-weight-bold text-body-2 mr-auto" style="min-width:110px">Transfer./Dep.</span>
                  <v-text-field
                    v-model.number="pagosMixtos.transDepo"
                    type="number" min="0" dense outlined hide-details
                    prefix="₡" class="payment-amount-field" style="max-width:160px"
                    @input="onPagoMixtoChange" @focus="$event.target.select()"
                  ></v-text-field>
                </div>
                <v-divider></v-divider>

                <!-- Cheque -->
                <div class="payment-method-row d-flex align-center px-4 py-2" :class="pagosMixtos.cheque > 0 ? ($vuetify.theme.dark ? 'brown darken-4' : 'brown lighten-5') : ''">
                  <v-icon :color="pagosMixtos.cheque > 0 ? 'brown' : 'grey'" class="mr-3" size="22">mdi-checkbook</v-icon>
                  <span class="font-weight-bold text-body-2 mr-auto" style="min-width:110px">Cheque</span>
                  <v-text-field
                    v-model.number="pagosMixtos.cheque"
                    type="number" min="0" dense outlined hide-details
                    prefix="₡" class="payment-amount-field" style="max-width:160px"
                    @input="onPagoMixtoChange" @focus="$event.target.select()"
                  ></v-text-field>
                </div>
              </v-card>
            </div>

            <!-- INDICADOR PENDIENTE / VUELTO -->
            <v-sheet
              rounded="xl"
              class="pa-3 mb-4 d-flex justify-space-between align-center"
              :color="pendienteMixto < 0
                ? ($vuetify.theme.dark ? 'rgba(76,175,80,0.15)' : 'green lighten-5')
                : pendienteMixto === 0
                  ? ($vuetify.theme.dark ? 'rgba(76,175,80,0.15)' : 'green lighten-5')
                  : ($vuetify.theme.dark ? 'rgba(255,152,0,0.15)' : 'orange lighten-5')"
              outlined
            >
              <div>
                <div class="text-caption font-weight-bold text-uppercase" :class="pendienteMixto > 0 ? 'orange--text' : 'success--text'">
                  {{ pendienteMixto > 0 ? 'Pendiente por asignar' : (pendienteMixto === 0 ? '✅ Monto completo' : '💵 Vuelto en Efectivo') }}
                </div>
                <div class="text-h6 font-weight-black" :class="pendienteMixto > 0 ? 'orange--text' : 'success--text'">
                  {{ pendienteMixto >= 0 ? '' : '-' }}₡{{ Math.abs(pendienteMixto).toLocaleString() }}
                </div>
              </div>
              <div v-if="pendienteMixto < 0" class="text-right">
                <div class="text-caption grey--text">Solo efectivo da vuelto</div>
              </div>
            </v-sheet>

            <!-- RECIBIR DÓLARES (solo cuando hay efectivo) -->
            <v-expand-transition>
              <div v-if="pagosMixtos.efectivo > 0 && cajaPOS && (cajaPOS.tdc || 0) > 0" class="d-flex align-center mb-4">
                <v-switch v-model="cobrarDatos.pagoEnUSD" label="Recibir parte en Dólares ($)" inset color="success" hide-details dense class="mt-0 pt-0 mr-4"></v-switch>
                <div v-if="cobrarDatos.pagoEnUSD" class="d-flex align-center">
                  <v-text-field
                    v-model="cobrarDatos.pagaConUSD"
                    @input="calcularConversionUSD"
                    label="Paga con $"
                    outlined dense prefix="$" type="number"
                    hide-details style="max-width:120px"
                    @focus="$event.target.select()"
                  ></v-text-field>
                  <span class="ml-3 success--text font-weight-bold">Vuelto ${{ cobrarDatos.vueltoUSD || '0.00' }}</span>
                </div>
              </div>
            </v-expand-transition>

            <!-- BOTONES DE ACCIÓN -->
            <v-row dense class="mt-2 mx-0">
              <v-col cols="12" sm="4">
                <v-btn
                  color="success" block x-large class="elevation-4 font-weight-bold"
                  style="font-size: 0.85rem; border-radius: 12px;"
                  :disabled="pendienteMixto > 0"
                  @click="save"
                >
                  <v-icon left>mdi-check</v-icon>
                  Solo Cobrar
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  color="primary" block x-large class="elevation-4 font-weight-bold"
                  style="font-size: 0.85rem; border-radius: 12px;"
                  :disabled="pendienteMixto > 0"
                  @click="getTiqueteReport"
                >
                  <v-icon left>mdi-printer</v-icon>
                  Imprimir
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  color="info" block x-large class="elevation-4 font-weight-bold"
                  style="font-size: 0.85rem; border-radius: 12px;"
                  :disabled="pendienteMixto > 0"
                  @click="compartirTiqueteA"
                >
                  <v-icon left>mdi-share-variant</v-icon>
                  Compartir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>


      <!-- MODAL DE CIERRE DE CAJA BILINGÜE & PRO -->
      <v-dialog v-model="dialogCierreCaja" max-width="850px" persistent>
        <v-card flat class="overflow-hidden" style="border-radius:4px" :dark="$vuetify.theme.dark">
          <!-- HEADER -->
          <div class="pa-5 white--text d-flex align-center justify-space-between" style="background-color:#37474f !important">
            <div class="d-flex align-center">
              <v-icon color="white" size="32" class="mr-4">mdi-cash-register</v-icon>
              <div>
                <h3 class="text-h6 font-weight-black letter-spacing-1 mb-0 line-height-1">Cierre de Caja</h3>
                <div class="text-caption opacity-80 text-uppercase letter-spacing-1">Gestión de Arqueo y Auditoría</div>
              </div>
            </div>
            <v-chip color="white" light small class="font-weight-black px-3">{{ user.nombre }}</v-chip>
          </div>

          <!-- TABS SYSTEM -->
          <v-tabs v-model="tabCierre" color="#37474f" grow slider-size="3">
            <v-tab class="font-weight-bold">
              <v-icon left>mdi-file-chart-outline</v-icon>
              Resumen Sistema
            </v-tab>
            <v-tab class="font-weight-bold">
              <v-icon left>mdi-calculator-variant</v-icon>
              Conteo Físico
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabCierre">
            <!-- TAB 1: RESUMEN DEL SISTEMA -->
            <v-tab-item class="pa-5">
              <v-row>
                <v-col cols="12" md="6">
                   <v-card outlined class="rounded-lg pa-4 h-100" :class="$vuetify.theme.dark ? 'grey darken-4 border-grey-darken-3' : 'grey lighten-5 border-grey-lighten-2'">
                      <div class="text-overline mb-2 font-weight-black" :class="$vuetify.theme.dark ? 'primary--text text--lighten-2' : 'blue-grey--text text--darken-3'">Flujo de Caja (Colones)</div>
                      <div class="d-flex justify-space-between align-center mb-2">
                        <span class="text-body-2 font-weight-medium" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-4'">Fondo Apertura</span>
                        <span class="text-body-1 font-weight-bold">₡{{ cierreCajaResumen.montoApertura || 0 }}</span>
                      </div>
                      <div class="d-flex justify-space-between align-center mb-2">
                        <span class="text-body-2 font-weight-medium text-success" :class="$vuetify.theme.dark ? 'success--text text--lighten-2' : ''">Entradas</span>
                        <span class="text-body-1 font-weight-bold success--text font-weight-black">₡{{ cierreCajaResumen.montoIngresos || 0 }}</span>
                      </div>
                      <div class="d-flex justify-space-between align-center mb-2">
                        <span class="text-body-2 font-weight-medium text-error" :class="$vuetify.theme.dark ? 'error--text text--lighten-2' : ''">Salidas</span>
                        <span class="text-body-1 font-weight-bold error--text font-weight-black">₡{{ cierreCajaResumen.montoSalidas || 0 }}</span>
                      </div>
                      <v-divider class="my-3"></v-divider>
                      <div class="d-flex justify-space-between align-center font-weight-black">
                        <span class="text-subtitle-1 font-weight-black" :class="$vuetify.theme.dark ? 'grey--text text--lighten-4' : 'blue-grey--text text--darken-4'">Total Esperado</span>
                        <span class="text-h6 font-weight-black" :class="$vuetify.theme.dark ? 'primary--text text--lighten-1' : 'primary--text'">₡{{ cierreCajaResumen.montoCierreCaja }}</span>
                      </div>
                   </v-card>
                </v-col>
                <v-col cols="12" md="6">
                   <v-card outlined class="rounded-lg pa-4 h-100" :class="$vuetify.theme.dark ? 'grey darken-4 border-grey-darken-3' : 'grey lighten-5 border-grey-lighten-2'">
                      <div class="text-overline mb-2 font-weight-black" :class="$vuetify.theme.dark ? 'primary--text text--lighten-2' : 'blue-grey--text text--darken-3'">Desglose de Ventas</div>
                      <div class="d-flex justify-space-between align-center mb-2" v-if="cierreCajaResumen.montoEfectivoUSD > 0">
                        <span class="text-body-2 font-weight-medium" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-4'">Efectivo en Dólares ($)</span>
                        <span class="text-body-1 font-weight-black success--text">${{ cierreCajaResumen.montoEfectivoUSD || 0 }}</span>
                      </div>
                      <div class="d-flex justify-space-between align-center mb-2">
                        <span class="text-body-2 font-weight-medium" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-4'">Ventas Efectivo</span>
                        <span class="text-body-1 font-weight-bold">₡{{ cierreCajaResumen.montoEfectivo || 0 }}</span>
                      </div>
                      <div class="d-flex justify-space-between align-center mb-2">
                        <span class="text-body-2 font-weight-medium" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-4'">Ventas Tarjeta</span>
                        <span class="text-body-1 font-weight-bold">₡{{ cierreCajaResumen.montoTarjeta || 0 }}</span>
                      </div>
                      <div class="d-flex justify-space-between align-center">
                        <span class="text-body-2 font-weight-medium" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-4'">Ventas SINPE</span>
                        <span class="text-body-1 font-weight-bold">₡{{ cierreCajaResumen.montoSinpe || 0 }}</span>
                      </div>
                   </v-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- TAB 2: CONTEO FÍSICO DE BILLETES Y MONEDAS 🎰⚖️ -->
            <v-tab-item class="pa-5">
              <v-row dense>
                <!-- BILLETES HEADER -->
                <v-col cols="12" md="6">
                  <div class="d-flex align-center mb-3">
                    <v-icon color="primary" class="mr-2">mdi-banknote-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-black">Billetes (CRC)</span>
                  </div>
                  <v-card outlined class="rounded-lg overflow-hidden" :class="$vuetify.theme.dark ? 'grey darken-4 border-grey-darken-3' : 'border-grey-lighten-2'">
                    <v-simple-table dense :dark="$vuetify.theme.dark">
                      <thead>
                        <tr :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'">
                          <th class="text-left font-weight-black py-2" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'">Denom.</th>
                          <th class="text-center font-weight-black py-2" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'" style="width: 100px;">Cant.</th>
                          <th class="text-right font-weight-black py-2" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'">Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(code, denom) in {20000:'b20000', 10000:'b10000', 5000:'b5000', 2000:'b2000', 1000:'b1000'}" :key="denom">
                          <td class="font-weight-black" :class="$vuetify.theme.dark ? 'grey--text text--lighten-3' : 'grey--text text--darken-3'">₡{{ (parseInt(denom)).toLocaleString() }}</td>
                          <td class="py-1">
                            <v-text-field v-model.number="arqueoFisico.billetes[code]" type="number" dense hide-details solo flat height="32" class="centered-input-cierre" @focus="$event.target.select()"></v-text-field>
                          </td>
                          <td class="text-right font-weight-black" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'">₡{{ ((arqueoFisico.billetes[code] || 0) * parseInt(denom)).toLocaleString() }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>

                <!-- MONEDAS HEADER -->
                <v-col cols="12" md="6">
                  <div class="d-flex align-center mb-3">
                    <v-icon color="secondary" class="mr-2">mdi-coins</v-icon>
                    <span class="text-subtitle-2 font-weight-black">Monedas (CRC)</span>
                  </div>
                  <v-card outlined class="rounded-lg overflow-hidden" :class="$vuetify.theme.dark ? 'grey darken-4 border-grey-darken-3' : 'border-grey-lighten-2'">
                    <v-simple-table dense :dark="$vuetify.theme.dark">
                      <thead>
                        <tr :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'">
                          <th class="text-left font-weight-black py-2" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'">Denom.</th>
                          <th class="text-center font-weight-black py-2" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'" style="width: 100px;">Cant.</th>
                          <th class="text-right font-weight-black py-2" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'">Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(code, denom) in {500:'m500', 100:'m100', 50:'m50', 25:'m25', 10:'m10', 5:'m5'}" :key="denom">
                          <td class="font-weight-black" :class="$vuetify.theme.dark ? 'grey--text text--lighten-3' : 'grey--text text--darken-3'">₡{{ (parseInt(denom)).toLocaleString() }}</td>
                          <td class="py-1">
                            <v-text-field v-model.number="arqueoFisico.monedas[code]" type="number" dense hide-details solo flat height="32" class="centered-input-cierre" @focus="$event.target.select()"></v-text-field>
                          </td>
                          <td class="text-right font-weight-black" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'blue-grey--text text--darken-3'">₡{{ ((arqueoFisico.monedas[code] || 0) * parseInt(denom)).toLocaleString() }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>

                <!-- OTROS & DOLARES (BILINGUE) -->
                <v-col cols="12" class="mt-4">
                   <v-card outlined class="rounded-lg pa-4 border-primary-lighten-2" :color="$vuetify.theme.dark ? 'grey darken-4' : 'blue lighten-5'">
                      <v-row dense align="center">
                        <v-col cols="12" md="3">
                           <v-text-field v-model.number="arqueoFisico.dolares" label="Contado USD ($)" type="number" outlined dense rounded-lg hide-details prefix="$" class="custom-closing-input shadow-sm" @focus="$event.target.select()"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                           <v-text-field v-model.number="arqueoFisico.otros" label="Otros (CRC)" type="number" outlined dense rounded-lg hide-details prefix="₡" class="custom-closing-input shadow-sm" @focus="$event.target.select()"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                           <div class="d-flex fill-height align-center justify-end">
                              <div class="text-right mr-6">
                                 <div class="text-caption font-weight-bold text-uppercase" :class="$vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text'">Total Contado (CRC + USD)</div>
                                 <div class="text-h6 font-weight-black primary--text">₡{{ totalFisicoContado.toLocaleString() }}</div>
                              </div>
                              <div class="text-right">
                                 <div class="text-caption font-weight-bold text-uppercase" :class="$vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text'">Total Contado (USD)</div>
                                 <div class="text-h6 font-weight-black success--text">${{ totalFisicoDolares.toLocaleString() }}</div>
                              </div>
                           </div>
                        </v-col>
                      </v-row>
                   </v-card>
                </v-col>

                <!-- COMPARATIVE SUMMARY (SOBRANTE/FALTANTE) -->
                <v-col cols="12" class="mt-4">
                   <v-sheet 
                      rounded="lg" 
                      class="pa-4 d-flex justify-space-around align-center flex-wrap" 
                      :color="$vuetify.theme.dark ? (diferenciaCaja >= 0 ? (diferenciaCaja === 0 ? 'rgba(255,255,255,0.05)' : 'rgba(76, 175, 80, 0.15)') : 'rgba(244, 67, 54, 0.15)') : (diferenciaCaja >= 0 ? (diferenciaCaja === 0 ? 'grey lighten-4' : 'success lighten-5') : 'error lighten-5')" 
                      outlined
                      :class="$vuetify.theme.dark ? 'border-grey-darken-3' : ''"
                    >
                      <div class="text-center px-4">
                         <div class="text-caption font-weight-black uppercase" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'grey--text'">Diferencia CRC</div>
                         <div class="text-h5 font-weight-black" :class="diferenciaCaja >= 0 ? (diferenciaCaja === 0 ? 'grey--text' : 'success--text') : 'error--text'">
                            {{ diferenciaCaja >= 0 ? '+' : '' }}₡{{ diferenciaCaja.toLocaleString() }}
                         </div>
                      </div>
                      <v-divider vertical class="mx-6" :dark="$vuetify.theme.dark"></v-divider>
                      <div class="text-center px-4">
                         <div class="text-caption font-weight-black uppercase" :class="$vuetify.theme.dark ? 'grey--text text--lighten-2' : 'grey--text'">Diferencia USD</div>
                         <div class="text-h5 font-weight-black" :class="diferenciaCajaDolares >= 0 ? (diferenciaCajaDolares === 0 ? 'grey--text' : 'success--text') : 'error--text'">
                            {{ diferenciaCajaDolares >= 0 ? '+' : '' }}${{ diferenciaCajaDolares.toLocaleString() }}
                         </div>
                      </div>
                      <v-divider vertical class="mx-6" v-if="diferenciaCaja !== 0 || diferenciaCajaDolares !== 0" :dark="$vuetify.theme.dark"></v-divider>
                      <div class="d-flex align-center" v-if="diferenciaCaja !== 0 || diferenciaCajaDolares !== 0">
                         <v-icon large :color="diferenciaCaja >= 0 && diferenciaCajaDolares >= 0 ? 'success' : 'error'">
                            {{ diferenciaCaja >= 0 && diferenciaCajaDolares >= 0 ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                         </v-icon>
                         <div class="ml-2 font-weight-black" :class="diferenciaCaja >= 0 && diferenciaCajaDolares >= 0 ? 'success--text' : 'error--text'">
                            {{ diferenciaCaja >= 0 && diferenciaCajaDolares >= 0 ? 'Cuadre con Sobrante' : 'Diferencia en Caja' }}
                         </div>
                      </div>
                      <div class="d-flex align-center" v-else>
                         <v-icon large color="success">mdi-check-all</v-icon>
                         <div class="ml-2 font-weight-black success--text text-uppercase">Caja Perfecta</div>
                      </div>
                   </v-sheet>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>

          <v-divider></v-divider>

          <v-divider></v-divider>
          <v-card-actions class="pa-4 d-flex justify-space-between">
            <v-btn text class="font-weight-bold" style="border-radius:4px" @click="cerrarVentanaCierre" depressed>
              <v-icon left>mdi-close</v-icon>
              {{ cashOpened ? 'Regresar al POS' : 'Cerrar Ventana' }}
            </v-btn>
            <div class="d-flex">
               <v-btn v-if="cashOpened" color="teal darken-1" dark depressed style="border-radius:4px" class="font-weight-bold px-8 mr-3" @click="confirmarCierreCaja">
                <v-icon left>mdi-check-decagram</v-icon>
                Confirmar Cierre
              </v-btn>
               <v-btn style="background-color:#37474f !important;border-radius:4px" dark depressed class="font-weight-bold px-8" @click="imprimirCierreCaja">
                <v-icon left>mdi-printer</v-icon>
                Imprimir Cierre
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent transition="dialog-bottom-transition" v-model="dialogReport" max-width="400">
        <div v-if="showNewData">
          <TiqueteReport v-bind:allwedOnly="true" v-bind:tiqueteInfo="tiqueteInfo" @clicked="saveReport" @closed2="closed2" />
        </div>
      </v-dialog>

      <v-dialog v-model="dialogInformacionAdicional" max-width="700px">
        <v-card flat class="overflow-hidden" style="border-radius:4px" :dark="$vuetify.theme.dark">
          <v-toolbar flat height="56" style="background-color:#37474f !important" dark>
            <v-icon class="mr-2">mdi-information-outline</v-icon>
            <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem">Datos Adicionales de Venta</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="cancelarInformacionAdicional"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="12" md="8">
                <v-text-field v-model="editedItem.clientecorreo" label="Correo Electrónico" outlined rounded-lg dense prepend-inner-icon="mdi-email-outline"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select label="Condición Venta" v-model="editedItem.condicionVenta" :items="condicionesVenta" item-text="descripcion" item-value="codigo" outlined rounded-lg dense></v-select>
              </v-col>
              <v-col cols="12" md="4">
                 <v-select label="Medio de pago" v-model="editedItem.medioPago" :items="mediosPago" item-text="descripcion" item-value="codigo" outlined rounded-lg dense></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select label="Moneda" v-model="editedItem.moneda" :items="monedas" item-text="md_nombre" item-value="md_codigo" @change="changeMonedas" outlined rounded-lg dense></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="editedItem.tipoCambio" label="Tipo de Cambio" type="number" step="any" min="1" outlined rounded-lg dense @focus="$event.target.select()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="actividades.length > 1">
                <v-select
                  v-model="editedItem.codigoActividad"
                  :items="actividades"
                  item-text="descripcion"
                  item-value="codigo"
                  label="Actividad Económica Emisor"
                  outlined rounded-lg dense
                  prepend-inner-icon="mdi-briefcase-outline"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" v-if="esFactura && clienteActividades.length > 1">
                <v-select
                  v-model="editedItem.clienteCodigoActividad"
                  :items="clienteActividades"
                  item-text="descripcion"
                  item-value="codigo"
                  label="Actividad Económica Receptor"
                  outlined rounded-lg dense
                  prepend-inner-icon="mdi-briefcase-account-outline"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn style="background-color:#37474f !important;border-radius:4px" dark depressed class="px-8 font-weight-bold" @click="cancelarInformacionAdicional">
              <v-icon left>mdi-content-save-outline</v-icon> Guardar Cambios
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogCajaMov" max-width="480px" persistent>
        <v-card flat class="overflow-hidden" style="border-radius:4px" :dark="$vuetify.theme.dark">

          <!-- HEADER -->
          <v-toolbar flat height="56" style="background-color:#37474f !important" dark>
            <v-icon class="mr-2">mdi-cash-register</v-icon>
            <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem">Movimiento de Caja</v-toolbar-title>
            <v-spacer />
            <v-btn icon dark @click="dialogCajaMov = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-6">

            <!-- SELECTOR TIPO: BOTONES VISUALES -->
            <div class="mb-5">
              <div class="caption font-weight-bold mb-2 grey--text text-uppercase letter-spacing-1">
                Tipo de Movimiento
              </div>
              <v-row dense>
                <v-col cols="6">
                  <v-btn
                    block
                    rounded-lg
                    large
                    :outlined="cajaMovItem.tipo !== 1"
                    :depressed="cajaMovItem.tipo === 1"
                    color="primary"
                    :dark="cajaMovItem.tipo === 1"
                    @click="cajaMovItem.tipo = 1"
                    class="font-weight-bold"
                  >
                    <v-icon left>mdi-arrow-down-bold</v-icon>
                    Entrada
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    block
                    rounded-lg
                    large
                    :outlined="cajaMovItem.tipo !== 2"
                    :depressed="cajaMovItem.tipo === 2"
                    color="error"
                    :dark="cajaMovItem.tipo === 2"
                    @click="cajaMovItem.tipo = 2"
                    class="font-weight-bold"
                  >
                    <v-icon left>mdi-arrow-up-bold</v-icon>
                    Salida
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <!-- DESCRIPCIÓN -->
            <v-text-field
              v-model="cajaMovItem.descripcion"
              label="Descripción / Concepto"
              placeholder="Ej: Pago a proveedor, cambio inicial..."
              outlined
              rounded-lg
              dense
              prepend-inner-icon="mdi-text-box-outline"
              :color="cajaMovItem.tipo === 1 ? 'primary' : 'error'"
              class="mb-2"
            ></v-text-field>

            <!-- MONTO -->
            <v-text-field
              v-model="cajaMovItem.monto"
              label="Monto"
              type="number"
              outlined
              rounded-lg
              dense
              prefix="₡"
              prepend-inner-icon="mdi-cash"
              :color="cajaMovItem.tipo === 1 ? 'primary' : 'error'"
              @focus="$event.target.select()"
            ></v-text-field>

            <!-- PREVIEW DEL MONTO -->
            <v-sheet
              v-if="cajaMovItem.monto > 0"
              :color="cajaMovItem.tipo === 1 ? 'primary lighten-5' : 'error lighten-5'"
              class="rounded-xl pa-3 d-flex align-center justify-center"
            >
              <v-icon :color="cajaMovItem.tipo === 1 ? 'primary' : 'error'" class="mr-2">
                {{ cajaMovItem.tipo === 1 ? 'mdi-plus-circle' : 'mdi-minus-circle' }}
              </v-icon>
              <span
                class="text-h5 font-weight-black"
                :class="cajaMovItem.tipo === 1 ? 'primary--text' : 'error--text'"
              >
                ₡{{ Number(cajaMovItem.monto || 0).toLocaleString('es-CR', { minimumFractionDigits: 2 }) }}
              </span>
            </v-sheet>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4 d-flex justify-space-between">
            <v-btn text class="font-weight-bold" style="border-radius:4px" @click="dialogCajaMov = false">
              <v-icon left small>mdi-close</v-icon> Cancelar
            </v-btn>
            <v-btn
              depressed
              large
              style="border-radius:4px"
              class="font-weight-bold px-8"
              :color="cajaMovItem.tipo === 2 ? 'error' : '#37474f'"
              dark
              :disabled="!cajaMovItem.tipo || !cajaMovItem.monto || cajaMovItem.monto <= 0"
              @click="movCajaPOS"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Registrar Movimiento
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>


      <!-- GLOBAL UTILS (SEARCH DIALOGS) -->
      <v-dialog persistent transition="dialog-bottom-transition" v-model="dialog">
        <div v-if="showNewData">
          <BuscarClientes v-bind:allwedOnly="true" @clicked="selected" @closed="closed" />
        </div>
      </v-dialog>
      
      <v-dialog persistent transition="dialog-bottom-transition" v-model="dialogBuscarArticulos">
        <div v-if="showNewDataArti">
          <BuscarArticulos v-bind:allwedOnly="true" @clicked="selectedArticulos" @closed="closed" />
        </div>
      </v-dialog>

      <!-- ELEMENTO OCULTO PARA EXPORTAR TIQUETE COMO IMAGEN -->
      <div style="position: absolute; left: -9999px; top: -9999px;">
         <div v-html="tiqueteInfo.idTiquete" ref="hiddenTicketPrint" id="hidden-ticket-print" style="width: 280px; background: white; color: black; padding: 15px;"></div>
      </div>

      <!-- DIALOG NUEVO CLIENTE RÁPIDO -->
      <v-dialog v-model="dialogNuevoCliente" max-width="520" persistent>
        <v-card flat class="overflow-hidden" style="border-radius:4px">
          <v-toolbar flat height="56" style="background-color:#37474f !important" dark>
            <v-icon class="mr-2">mdi-account-plus</v-icon>
            <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem">Nuevo Cliente</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="dialogNuevoCliente = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="8">
                <v-select
                  v-model="nuevoCliente.tipoId"
                  :items="tiposIdentificacion"
                  item-text="descripcion"
                  item-value="tipoId"
                  label="Tipo Identificación"
                  outlined dense rounded-lg
                  prepend-inner-icon="mdi-card-account-mail-outline"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="nuevoCliente.cedula"
                  label="Identificación"
                  outlined dense rounded-lg
                  type="number"
                  prepend-inner-icon="mdi-account-details-outline"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn color="primary" block rounded-lg depressed height="40" dark :loading="nuevoClienteHaciendaLoading" @click="getHaciendaNuevoCliente">
                  <v-icon left size="18">mdi-file-find</v-icon>
                  Hacienda
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="nuevoCliente.nombre"
                  label="Nombre o Razón Social"
                  outlined dense rounded-lg
                  prepend-inner-icon="mdi-office-building-outline"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="nuevoCliente.correo"
                  label="Correo Electrónico"
                  outlined dense rounded-lg
                  prepend-inner-icon="mdi-email-outline"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="nuevoCliente.moneda"
                  :items="monedas"
                  item-text="md_nombre"
                  item-value="md_codigo"
                  label="Moneda"
                  outlined dense rounded-lg
                  prepend-inner-icon="mdi-cash"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="nuevoCliente.areaTel"
                  label="Área"
                  outlined dense rounded-lg
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="nuevoCliente.telefono"
                  label="Teléfono"
                  outlined dense rounded-lg
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="nuevoCliente.esReceptor"
                  label="Es Receptor de Factura Electrónica"
                  color="primary"
                  class="mt-0"
                ></v-checkbox>
              </v-col>

              <!-- UBICACIÓN — solo si es receptor -->
              <template v-if="nuevoCliente.esReceptor">
                <v-col cols="12"><v-divider></v-divider></v-col>
                <v-col cols="12">
                  <span class="caption primary--text font-weight-bold text-uppercase">Ubicación</span>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="nuevoCliente.provincia"
                    :items="provincias"
                    item-text="pr_nombre"
                    item-value="pr_codigo"
                    label="Provincia"
                    outlined dense rounded-lg clearable
                    @change="ncGetCantones"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="nuevoCliente.canton"
                    :items="ncCantones"
                    item-text="ct_nombre"
                    item-value="ct_codigo"
                    label="Cantón"
                    outlined dense rounded-lg clearable
                    :disabled="!nuevoCliente.provincia"
                    @change="ncGetDistritos"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="nuevoCliente.distrito"
                    :items="ncDistritos"
                    item-text="dt_nombre"
                    item-value="dt_codigo"
                    label="Distrito"
                    outlined dense rounded-lg clearable
                    :disabled="!nuevoCliente.canton"
                    @change="ncActualizarDireccion"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="nuevoCliente.direccion"
                    label="Dirección Exacta"
                    outlined dense rows="2"
                    class="rounded-xl"
                    placeholder="Se completa automáticamente al elegir distrito"
                  ></v-textarea>
                </v-col>
              </template>

              <!-- ACTIVIDADES ECONÓMICAS -->
              <v-col cols="12" v-if="ncActividades.length > 0">
                <v-divider class="mb-3"></v-divider>
                <span class="caption primary--text font-weight-bold text-uppercase">
                  <v-icon left small color="primary">mdi-briefcase-outline</v-icon>
                  Actividades Económicas
                </span>
                <v-simple-table dense class="mt-2">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Estado</th>
                        <th class="text-center">Defecto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="act in ncActividades" :key="act.codigo">
                        <td>{{ act.codigo }}</td>
                        <td>{{ act.descripcion }}</td>
                        <td>{{ act.estado }}</td>
                        <td class="text-center">
                          <v-radio-group v-model="ncActividadDefecto" hide-details dense class="mt-0 pt-0">
                            <v-radio :value="act.codigo" color="primary" @change="ncMarcarDefecto(act)"></v-radio>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-btn text class="font-weight-bold" style="border-radius:4px" @click="dialogNuevoCliente = false">Cancelar</v-btn>
            <v-spacer />
            <v-btn style="background-color:#37474f !important;border-radius:4px" dark depressed class="px-6 font-weight-bold" :loading="nuevoClienteLoading" @click="guardarNuevoCliente">
              <v-icon left>mdi-content-save-outline</v-icon>
              Crear y Seleccionar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </v-row> <!-- END pos-split-container -->
  </div> <!-- END renderPage -->
</template>

<script>
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";
import axios from "axios";

import { ProductService } from "../services/ProductService";

import Snackbar from "./shared/Snackbar.vue";
import BuscarClientes from "./BuscarClientes.vue";
import BuscarArticulos from "./BuscarArticulos.vue";
import TiqueteReport from "./TiqueteReport.vue";
import CashOpening from "./CashOpening.vue";
import { CashService } from "../services/CashService";
//import PagoSinpe from "./PagoSinpe.vue";




export default {
  components: {
    Snackbar,
    BuscarArticulos,
    BuscarClientes,
    TiqueteReport,
    CashOpening,
    //PagoSinpe,
  },
  // dark: true,
  data() {
    return {
      codigoBarras: "",
      miHtml: `<strong>Soy HTML</strong> y puedo
    <br>Ser
    <br>Inyectado
    <br>
    en Vue. Aquí un link:
    <a href="//parzibyte.me/blog">parzibyte.me/blog</a>`,
      miHtml2: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Tiquete</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      font-size: 11px;
    }
    .ticket {
      width: 250px;
      margin: 0 auto;
      /* border: 1px solid #000; */
      padding: 5px;
    }
    .header {
      font-weight: bold;
      text-align: center; 
      font-size: 14px;
    }
    .item {
      text-align: center; 
      margin-bottom: 1px;
      font-size: 12px;
    }
    .item:last-child {
      margin-bottom: 0;
    }
    .total {
      font-weight: bold;
      text-align: center; 
      font-size: 12px;
    }
    .footer {
      margin-top: 5px;
      text-align: center; 
    }
  </style>
</head>
<body>

<div class="ticket">
    <div class="header">
        <span>Tiquete</span>
    </div>
    <div class="header">
        <span>Mini Super S&D</span>
    </div>
    <div class="header">
        <span>Tel: 83733396</span>
    </div>

    <hr>
  <!-- <div class="header">
    <h4>Tiquete</h4>
    <h4>Mini Super S&D</h4>
    <h4>Tel: 83733396</h4>
  </div> -->
  
  <div class="item">
    <span>N Factura:</span> <span>F-0000000158</span>
  </div>
  <div class="item">
    <span>Fecha:</span> <span>05-04-2024</span>
  </div>
  <div class="item">
    <span>Cliente:</span> <span>Marcelo López Brenes</span>
  </div>

  <div class="line"></div>

  <hr>

<table>
  <thead>
    <tr>
      <th>Producto</th>
      <th>Cant</th>
      <th>Precio</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Coca Cola Zero 355ml</td>
      <td>2</td>
      <td>₡700.00</td>
      <td>₡791.00</td>
    </tr>
    <tr>
      <td>Fruta de pan, fresca o refrigerada</td>
      <td>1</td>
      <td>₡6,000.00</td>
      <td>₡6,780.00</td>
    </tr>
  </tbody>
</table>

<hr>

  <div class="item">
    <span>Sub Total:</span> <span>₡6,000.00</span>
  </div>

  <div class="item">
    <span>Descuentos:</span> <span>₡00.00</span>
  </div>

  <hr>

  <div class="item">
    <span>Sub Total:</span> <span>₡6,000.00</span>
  </div>
  <div class="item">
    <span>Impuestos:</span> <span>₡780.00</span>
  </div>

  <div class="total">
    <span>Total:</span> <span>₡6,780.00</span>
  </div>
  <hr>
  <div class="footer">
    <p>Gracias por su compra!</p>
  </div>
</div>

</body>
</html>
`,
      btnAgregarCliente: false,
      btnAgregarArti: false,
      iconVisible: false,
      iconVisibleCedula: false,
      visibleBtnConsultar: true,
      visibleProgress: false,
      dialogSinpe: false,
      dialog: false,
      dialogArticulos: false,
      dialogCobrar: false,
      dialogInformacionAdicional: false,
      dialogArticuloError: false,
      dialogReport: false,
      dialogCierreCaja: false,
      dialogCajaMov: false,
      valid: false,
      incluirValid: true,
      consultarEstadoValid: false,
      cancelarValid: false,
      reenviarValid: false,
      imprimirValid: false,
      guardarValid: false,
      search: "",
      snackText: "",
      snackValue: false,
      tab2: 1,
      tabFactura: 0,
      dialogDelete: false,
      verPDF: false,
      verXMLFirmado: false,
      verXMLRespuesta: false,
      panel: [],
      panelResumen: [],
      licenciaValida: [],
      tiqueteInfo: {
        idTiquete: "",
        tipoTiquete: "",
      },
      tiposMov: [
        { codigo: 1, descripcion: "Entrada" },
        { codigo: 2, descripcion: "Salida" }
      ],
      headers: [
        {
          text: "Código",
          align: "start",
          value: "codigoFact",
        },
        {
          text: "Cliente",
          align: "start",
          value: "clienteNombre",
        },
        {
          text: "Fecha",
          align: "start",
          value: "fechaString",
        },
        {
          text: "Clave",
          align: "start",
          value: "clavehacienda",
        },
        {
          text: "Estado",
          align: "start",
          value: "estadoHacienda",
        },
        { text: "Editar", value: "actions", width: 50, sortable: false },
      ],
      headersDetalle: [
        {
          text: "Cant",
          align: "start",
          value: "cantidad",
          class: "primary",
        },
        {
          text: "Descripción",
          align: "start",
          value: "descripcion",
          class: "primary",
        },
        {
          text: "Unidad",
          align: "start",
          value: "unidad",
          class: "primary",
        },
        {
          text: "Precio",
          align: "start",
          value: "montoStr",
          class: "primary",
        },
        {
          text: "Total",
          align: "start",
          value: "totalLineaStr",
          class: "primary",
        },
        { text: "Editar", value: "actions", width: 50, sortable: false, class: "primary", },
        { text: "Eliminar", value: "delete", width: 70, sortable: false, class: "primary", },
      ],
      items: [],
      tiposIdentificacion: [],
      dialogNuevoCliente: false,
      nuevoClienteLoading: false,
      nuevoClienteHaciendaLoading: false,
      ncCantones: [],
      ncDistritos: [],
      ncActividades: [],
      ncActividadDefecto: null,
      nuevoCliente: {
        codigo: "", nombre: "", nombreComercial: "", moneda: "CRC",
        provincia: "", canton: "", distrito: "", barrio: "", direccion: "",
        esReceptor: false, correo: "", tipoId: "",
        areaTel: "506", telefono: "88888888", cedula: "", cia: "",
        esExonerado: false, exoTipo: "", exoNumDocumento: "",
        exoNomInstitucion: "", exoFecha: new Date().toISOString().substr(0, 10), exoPorcentaje: 0,
      },
      actividades: [],
      clienteActividades: [],
      condicionesVenta: [],
      mediosPago: [],
      sucursales: [],
      terminales: [],
      monedas: [],
      provincias: [],
      cantones: [],
      distritos: [],
      barrios: [],
      cliente: [],
      articulo: [],
      totales: [],
      lineasDetalle: [],
      tipoCambio: [],
      respuestaHacienda: [],
      resultadoGuardarTiquete: false,
      comprobante: [],
      editedIndex: -1,
      modelFactura: {
        comprobante: [],
        comprobanteDetalle: [],
      },
      editedItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "",
        fecha: new Date().toISOString().slice(0, 10),
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        clienteEsReceptor: false,
        mensajeHacienda: "",
        moneda: "",
        estadoHacienda: "",
        clavehacienda: "",
        subtotal: 0,
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalComprobante: 0,
        codigoDev: "",
        estadoDev: 0,
        consHacienda: "",
        condicionVenta: "01",
        medioPago: "01",
        plazoCredito: 0,
        sucursal: "",
        terminal: "",
        xml: "",
        xmlFirmado: "",
        respuestaHacienda: "",
        fechaHacienda: Date,
        totalGravado: 0,
        totalExento: 0,
        consHacReal: "",
        cedulaReceptor: "",
        ordenCompra: "",
        observacion: "",
        usuario: "",
        enviado: false,
        reenviado: false,
        totalServGravados: 0,
        totalServExentos: 0,
        totalServExonerado: 0,
        totalMercanciasExentas: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        totalIVADevuelto: 0,
        totalOtrosCargos: 0,
        totalIva1: 0,
        totalIva2: 0,
        totalIva4: 0,
        totalIva8: 0,
        totalIva13: 0,
        codigoActividad: "",
        emisorNombre: "",
        emisorNombreComercial: "",
        emisorTelefono: "",
        emisorCorreo: "",
        emisorDireccion: "",
        subTotal: 0,
        totalIVADevueltoStr: "",
        totalIva1Str: "",
        totalIva2Str: "",
        totalIva4Str: "",
        totalIva13Str: "",
        totalDescuentosStr: "",
        totalImpuestoStr: "",
        subtotalStr: "",
        totalComprobanteStr: "0.00",
        nombreTabla: "",
        contingenciaFact: "",
        contingenciaFecha: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        clienteCodigoActividad: "",
      },
      defaultItem: {
        cia: "",
        codigoFact: "",
        tipoFact: "",
        fecha: Date,
        tipoCambio: 1,
        clienteCod: "",
        clienteNombre: "",
        clienteCorreo: "",
        clienteCedula: "",
        clienteAreaTel: "",
        clienteTelefono: "",
        clienteNombreComercial: "",
        clienteProvincia: "",
        clienteCanton: "",
        clienteDistrito: "",
        clienteBarrio: "",
        clienteDireccion: "",
        clienteTipoId: "",
        clienteEsReceptor: false,
        mensajeHacienda: "",
        moneda: "",
        estadoHacienda: "",
        clavehacienda: "",
        subtotal: 0,
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalComprobante: 0,
        codigoDev: "",
        estadoDev: 0,
        consHacienda: "",
        condicionVenta: "01",
        medioPago: "01",
        plazoCredito: 0,
        sucursal: "",
        terminal: "",
        xml: "",
        xmlFirmado: "",
        respuestaHacienda: "",
        fechaHacienda: Date,
        totalGravado: 0,
        totalExento: 0,
        consHacReal: "",
        cedulaReceptor: "",
        ordenCompra: "",
        observacion: "",
        usuario: "",
        enviado: false,
        reenviado: false,
        totalServGravados: 0,
        totalServExentos: 0,
        totalServExonerado: 0,
        totalMercanciasExentas: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        totalIVADevuelto: 0,
        totalOtrosCargos: 0,
        totalIva1: 0,
        totalIva2: 0,
        totalIva4: 0,
        totalIva8: 0,
        totalIva13: 0,
        codigoActividad: "",
        emisorNombre: "",
        emisorNombreComercial: "",
        emisorTelefono: "",
        emisorCorreo: "",
        emisorDireccion: "",
        subTotal: 0,
        totalIVADevueltoStr: "",
        totalIva1Str: "",
        totalIva2Str: "",
        totalIva4Str: "",
        totalIva13Str: "",
        totalDescuentosStr: "",
        totalImpuestoStr: "",
        subtotalStr: "",
        totalComprobanteStr: "0.00",
        nombreTabla: "",
        contingenciaFact: "",
        contingenciaFecha: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        clienteCodigoActividad: "",
      },
      ciaItem: {
        nombre: "",
        nombreComercial: "",
        cedula: "",
        provincia: "",
        canton: "",
        distrito: "",
        barrio: "",
        direccion: "",
        sucursal: "",
        terminal: "",
        moneda: "",
        moneda2: "",
        usuariohacienda: "",
        clavehacienda: "",
        propietarioCert: "",
        certificado: "",
        claveCert: "",
        esProd: false,
        correo: "",
        claveCcorreo: "",
        smtpCorreo: "",
        puertoCorreo: "",
        usaSeguridad: false,
        areaTel: "",
        telefono: "",
        tipoId: "",
        codigoActividad: "",
        image: "",
      },
      cajaMovItem: {
        tipo: 0,
        monto: 0,
        descripcion: "",
      },
      detalleditedIndex: -1,
      detalleEditedItem: {
        cia: "",
        factura: "",
        tipoFact: "",
        numLinea: 0,
        cantidad: 0,
        articulo: "",
        descripcion: "",
        unidad: "",
        monto: 0,
        descuento: 0,
        totalLinea: 0,
        impuestosVentas: 0,
        sucursal: "",
        terminal: "",
        tipoCodigo: "",
        unidadMedidaComercial: "",
        impCodigo: "",
        impCodigoTarifa: "",
        impTarifa: "",
        cabys: "",
        porcDescuento: 0,
        tipoCambio: 0,
        tipoProducto: "",
        montoTotal: 0,
        subTotal: 0,
        impuestoNeto: 0,
        moneda: "",
        montoStr: "",
        totalLineaStr: "",
        cant_Dev: 0,
        linea_Dev: 0,
        clienteCod: "",
        clienteCedula: "",
      },
      detalleDefaultItem: {
        cia: "",
        factura: "",
        tipoFact: "",
        numLinea: 0,
        cantidad: 0,
        articulo: "",
        descripcion: "",
        unidad: "",
        monto: 0,
        descuento: 0,
        totalLinea: 0,
        impuestosVentas: 0,
        sucursal: "",
        terminal: "",
        tipoCodigo: "",
        unidadMedidaComercial: "",
        impCodigo: "",
        impCodigoTarifa: "",
        impTarifa: "",
        cabys: "",
        porcDescuento: 0,
        tipoCambio: 0,
        tipoProducto: "",
        montoTotal: 0,
        subTotal: 0,
        impuestoNeto: 0,
        moneda: "",
        montoStr: "",
        totalLineaStr: "",
        cant_Dev: 0,
        linea_Dev: 0,
        clienteCod: "",
        clienteCedula: "",
      },
      pagoInfo: {
        sucursal: "",
        terminal: "",
        total: 0,
      },
      cobrarDatos: {
        vuelto: "",
        pagaCon: "",
        pagaConUSD: "",
        vueltoUSD: 0,
        pagoEnUSD: false,
        ultimos4: "",
        refSinpe: "",
      },
      paymentMethod: 'cash',
      // 🆕 Pago Mixto: montos por método
      pagosMixtos: {
        efectivo:  0,
        tarjeta:   0,
        sinpe:     0,
        transDepo: 0,
        cheque:    0,
      },
      cashOpened: true,
      cajaPOS: [],
      cierreCajaResumen: [],
      tabCierre: 0,
      arqueoFisico: {
        billetes: {
          b20000: 0,
          b10000: 0,
          b5000: 0,
          b2000: 0,
          b1000: 0
        },
        monedas: {
          m500: 0,
          m100: 0,
          m50: 0,
          m25: 0,
          m10: 0,
          m5: 0
        },
        dolares: 0,
        otros: 0
      },
      opcionesSistemaCia: [],
      esSimplificado: false,
      forzarFactura: false,
      showNewData: false,
      showNewDataArti: false,
      nameRules: [(v) => !!v || "Campo requerido"],
      tempFile: "",
      modelFile: null,
    };
  },

  mounted() {
    this.scrollToElement();
    //this.focusInput();
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.barrasFocus.$refs.input.focus()
      })
    })
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    mostrarSelectorTipoDoc() {
      // Solo para régimen simplificado con cliente receptor activo
      return this.esSimplificado && this.editedItem.clienteEsReceptor === true;
    },
    esFactura() {
      if (!this.editedItem.clienteEsReceptor) return false;
      // Simplificado: el usuario decide con el toggle
      if (this.esSimplificado) return this.forzarFactura;
      // No simplificado: receptor siempre genera factura
      return true;
    },
    totalEnDolares() {
      if (!this.cajaPOS || !this.cajaPOS.tdc || this.cajaPOS.tdc == 0) return 0;
      return (this.editedItem.totalComprobante / this.cajaPOS.tdc).toFixed(2);
    },
    // 🆕 Pago Mixto: diferencia entre total y suma de métodos
    // positivo = falta asignar, 0 = exacto, negativo = vuelto en efectivo
    pendienteMixto() {
      const total = parseFloat(this.editedItem.totalComprobante) || 0;
      const asignado = (parseFloat(this.pagosMixtos.efectivo)  || 0)
                     + (parseFloat(this.pagosMixtos.tarjeta)   || 0)
                     + (parseFloat(this.pagosMixtos.sinpe)     || 0)
                     + (parseFloat(this.pagosMixtos.transDepo) || 0)
                     + (parseFloat(this.pagosMixtos.cheque)    || 0);
      return Math.round((total - asignado) * 100) / 100;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Agregar Articulo" : "Editar Articulo";
    },
    formattedFechaCierre() {
      return this.formatDate(this.cierreCajaResumen.fechaCierre);
    },

    // COMPUTED PROPERTIES PARA EL ARQUEO FÍSICO 💎📈🪄
    totalBilletes() {
      const b = this.arqueoFisico.billetes;
      return (b.b20000 * 20000) + (b.b10000 * 10000) + (b.b5000 * 5000) + (b.b2000 * 2000) + (b.b1000 * 1000);
    },
    totalMonedas() {
      const m = this.arqueoFisico.monedas;
      return (m.m500 * 500) + (m.m100 * 100) + (m.m50 * 50) + (m.m25 * 25) + (m.m10 * 10) + (m.m5 * 5);
    },
    totalFisicoContado() {
      const tdc = parseFloat(this.cierreCajaResumen.tdc || this.cajaPOS.tdc || 1);
      const colonesDeDolares = this.totalFisicoDolares * tdc;
      return this.totalBilletes + this.totalMonedas + parseFloat(this.arqueoFisico.otros || 0) + colonesDeDolares;
    },
    totalFisicoDolares() {
      return parseFloat(this.arqueoFisico.dolares || 0);
    },
    diferenciaCaja() {
      const esperado = parseFloat(this.cierreCajaResumen.montoCierreCaja || 0);
      return this.totalFisicoContado - esperado;
    },
    diferenciaCajaDolares() {
      const esperadoStr = (this.cierreCajaResumen.montoEfectivoUSD || 0).toString().replace('$', '').trim();
      const esperado = parseFloat(esperadoStr);
      return this.totalFisicoDolares - esperado;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    dialogArticulos(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.getCia();
    this.getActividades();
    this.getMonedas();
    this.getTiposIdentificacion();
    this.getMedioPago();
    this.getCondicionVenta();
    this.getOpcionesSistemaCia();
    this.getClientePOS();
    this.getCodigoTiquete();

    this.useCash(this)

    window.addEventListener('keydown', (e) => {
      if (e.key == 'F4') {
        console.log("se presionó F4");
        this.mostrarBuscarClientes();
      }
      if (e.key == 'F2') {
        console.log("se presionó F2");
        this.mostrarBuscarArticulos();
      }
      if (e.key == 'F8') {
        console.log("se presionó F8");
        this.mostrarVentanaCobro();
      }
      if (e.key == 'F9') {
        console.log("se presionó F9");
        this.cancelarVenta();
      }
    });
  },

  methods: {
    signalChange: function (evt) {
      this.snackText = "Si llega al escribir" + evt;
      this.snackValue = true;
    },

    mostrarVentanaCobro(montoRapido = null) {
      // Resetear pagos mixtos al abrir el modal
      this.pagosMixtos = { efectivo: 0, tarjeta: 0, sinpe: 0, transDepo: 0, cheque: 0 };
      this.cobrarDatos.pagaCon = "";
      this.cobrarDatos.vuelto = "";

      if (typeof montoRapido === 'number' && montoRapido > 0) {
        if (montoRapido < this.editedItem.totalComprobante) {
          this.snackText = "El billete rápido de ₡" + montoRapido.toLocaleString('es-CR') + " no cubre el Total a Pagar.";
          this.snackValue = true;
          return;
        }
        // Monto rápido → poner en efectivo
        this.pagosMixtos.efectivo = montoRapido;
      }

      this.dialogCobrar = true;
    },

    // 🆕 Pago Mixto: recalcula vuelto en efectivo al cambiar cualquier monto
    onPagoMixtoChange() {
      // El vuelto solo aplica si hay efectivo asignado de más
      const vuelto = -(this.pendienteMixto);
      this.cobrarDatos.vuelto = vuelto > 0 ? Math.round(vuelto) : 0;
    },


    getTiqueteReport() {
      this.saveReport('print');
    },

    ejecutarImpresion(printPreview = null) {
      if (!printPreview || printPreview.closed) {
        printPreview = window.open('', 'print_preview');
      }
      var printDocument = printPreview.document;
      printDocument.open();
      printDocument.write(`
        <html>
          <head><title>Impresión de Tiquete</title></head>
          <body>
            ${this.tiqueteInfo.idTiquete}
          </body>
        </html>
      `);
      printDocument.close();
      printPreview.print();
      setTimeout(() => {
        printPreview.close();
      }, 500);
    },

    compartirTiqueteA() {
      this.saveReport('share');
    },

    ejecutarCompartir() {
      this.$nextTick(() => {
        setTimeout(async () => {
          if (!("share" in navigator)) {
            this.snackText = "Tu dispositivo/navegador no soporta la función de compartir nativa.";
            this.snackValue = true;
            return;
          }
          const canvas = await html2canvas(this.$refs.hiddenTicketPrint);
          canvas.toBlob(async (blob) => {
            const files = [new File([blob], "tiquete.png", { type: blob.type })];
            const shareData = {
              title: "Tiquete de Compra",
              files,
            };
            if (navigator.canShare && navigator.canShare(shareData)) {
              try {
                await navigator.share(shareData);
              } catch (err) {
                 console.error("Share error:", err);
              }
            } else {
              this.snackText = "No se pudo preparar el archivo para compartir.";
              this.snackValue = true;
            }
          });
        }, 300);
      });
    },

    cancelarVenta() {
      if (confirm("¿Está seguro de que desea descartar la venta en proceso?")) {
        this.cerrar();
      }
    },

    cerrarCajaPOS() {
      // Ahora solo mostramos el resumen y el arqueo, no cerramos inmediatamente.
      this.prepararCierreCaja();
    },

    async prepararCierreCaja() {
      this.cierreCajaResumen = await CashService.getResumenCaja(this.strCia, this.cajaPOS.id, this.user.id);
      this.dialogCierreCaja = true;
    },

    async confirmarCierreCaja() {
      if (confirm("¿Está seguro de que desea finalizar el turno definitivamente? Esta acción no se puede deshacer.")) {
        this.cierreCajaResumen = await CashService.closeCash(this.strCia, this.cajaPOS.id, this.user.id);
        this.cashOpened = false;
        // Opcional: imprimir automáticamente al cerrar
        // this.imprimirCierreCaja();
      }
    },

    movCajaPOS() {
      this.crearMovCaja(this)
    },

    mostrarInformacionAdicional() {
      this.dialogInformacionAdicional = true;
    },

    mostrarCajaMov() {
      this.dialogCajaMov = true;
    },

    setFocus: function () {
      this.$refs.barrasFocus.focus();
    },

    focusInput() {
      this.$refs.barrasFocus.focus();
      //this.snackText = "el mae si llega aquí";
      //this.snackValue = true;
    },

    focusInputPagaCon() {
      this.$refs.pagaConFocus.focus();
    },

    scrollToElement() {
      const el = this.$refs.scrollToMe;

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: "smooth" });
      }
    },

    onOpenCash(args) {
      this.openCash(this, args[0], args[1])
    },

    setPaymentMethod(method) {
      this.paymentMethod = method;
      switch (method) {
        case "cash":
          this.editedItem.medioPago = "01"
          break
        case "card":
          this.editedItem.medioPago = "02"
          break
        case "sinpe":
          this.editedItem.medioPago = "05"
          break
      }
    },

    fetchProduct: async (me) => {
      const response = await ProductService.getByBarCode(me.strCia, me.codigoBarras)

      me.articulo = response;

      if (me.articulo.length == 0) {
        me.dialogArticuloError = true;
        // me.snackText = "El articulo no existe, por favor valide";
        // me.snackValue = true;
      } else {
        me.detalleEditedItem.cia = me.strCia;
        //me.detalleEditedItem.factura = me.editedItem.codigoFact; 
        me.detalleEditedItem.tipoFact = "04";
        me.detalleEditedItem.numLinea = 0;
        me.detalleEditedItem.unidad = me.articulo.unidad;
        me.detalleEditedItem.descuento = 0;
        me.detalleEditedItem.totalLinea = 0;
        me.detalleEditedItem.sucursal = me.editedItem.sucursal;
        me.detalleEditedItem.terminal = me.editedItem.terminal;
        me.detalleEditedItem.tipoCodigo = "01";
        me.detalleEditedItem.unidadMedidaComercial = "M2";
        me.detalleEditedItem.impCodigo = me.articulo.codigoImp;
        me.detalleEditedItem.impCodigoTarifa = me.articulo.codigoTarifa;
        me.detalleEditedItem.impTarifa = me.articulo.tarifa;
        me.detalleEditedItem.porcDescuento = 0;
        me.detalleEditedItem.monto = me.articulo.monto;
        me.detalleEditedItem.descripcion = me.articulo.nombre;
        me.detalleEditedItem.cantidad = 1;
        me.detalleEditedItem.cabys = me.articulo.cabys;
        me.detalleEditedItem.articulo = me.articulo.codigo;
        me.detalleEditedItem.tipoCambio = me.editedItem.tipoCambio;
        me.detalleEditedItem.impuestosVentas = me.articulo.tarifa;
        me.detalleEditedItem.tipoProducto = me.articulo.tipoArt;
        me.detalleEditedItem.moneda = me.editedItem.moneda;
        me.detalleEditedItem.clienteCod = me.editedItem.clienteCod;
        me.detalleEditedItem.clienteCedula = me.editedItem.clienteCedula;
        if (me.articulo.esGenerico) {
          me.dialogArticulos = true;
        } else {
          me.saveDetalleArticulo();
        }
        me.codigoBarras = "";
      }
    },

    onEnter: function () {
      let me = this;
      // this.snackText = "on enter event: " + this.codigoBarras;
      this.snackValue = false;
      if (this.codigoBarras !== "") {
        this.fetchProduct(me)
      }
    },

    // setBarrasFocus() {
    //   this.$nextTick(() => this.$refs.barrasFocus.$el.focus())
    // },

    changeText() {
      this.iconVisible = true;
    },

    activarIconoCedula() {
      this.iconVisibleCedula = true;
    },

    getData() {
      let me = this;
      axios
        .get(
          "api/Facturacion/GetComprobantes?cia=" +
          this.strCia +
          "&docNombre=Tiquetes&tipoDoc=04",
          {
            crossdomain: true,
          }
        )
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    printDate: function () {
      return new Date().tolocal;
    },

    getActividades() {
      let me = this;
      axios
        .get("api/General/getActividadesByCia?cia=" + this.strCia)
        .then(function (response) {
          me.actividades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCondicionVenta() {
      let me = this;
      axios
        .get("api/General/getCondicionVenta")
        .then(function (response) {
          me.condicionesVenta = response.data;
          me.editedItem.condicionVenta = me.condicionesVenta[0]["codigo"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMedioPago() {
      let me = this;
      axios
        .get("api/General/getMediosPago")
        .then(function (response) {
          me.mediosPago = response.data;
          me.editedItem.medioPago = me.mediosPago[0]["codigo"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCia() {
      let me = this;
      axios
        .get("api/Cias/getCia?ciaId=" + this.strCia)
        .then(function (response) {
          me.ciaItem = response.data;
          me.editedItem.emisorNombre = me.ciaItem.nombre;
          me.editedItem.emisorNombreComercial = me.ciaItem.nombreComercial;
          me.editedItem.codigoActividad = me.ciaItem.codigoActividad;
          me.editedItem.emisorTelefono = me.ciaItem.telefono;
          me.editedItem.emisorCorreo = me.ciaItem.correo;
          me.editedItem.emisorDireccion = me.ciaItem.direccion;
          me.editedItem.moneda = me.ciaItem.moneda;
          me.editedItem.cia = me.ciaItem.cedula;
          me.editedItem.fecha = me.printDate();

          me.getSucursales();
          me.pagoInfo.sucursal = me.ciaItem.sucursal;
          me.getTerminales(me.ciaItem.sucursal);
          me.editedItem.sucursal = me.ciaItem.sucursal;
          me.pagoInfo.terminal = me.ciaItem.terminal;
          me.esSimplificado = me.ciaItem.esSimplificado || false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getSucursales() {
      let me = this;
      axios
        .get("api/Cias/getSucursalesByCia?cia=" + this.strCia)
        .then(function (response) {
          me.sucursales = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTerminales(sucursal) {
      let me = this;
      axios
        .get(
          "api/Cias/getTerminales?cia=" + this.strCia + "&sucursal=" + sucursal
        )
        .then(function (response) {
          me.terminales = response.data;
          me.editedItem.terminal = me.terminales[0]["terminalId"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getBarrios() {
      let me = this;
      axios
        .get(
          "api/General/getBarrios?provincia=" +
          this.editedItem.clienteProvincia +
          "&canton=" +
          this.editedItem.clienteCanton +
          "&distrito=" +
          this.editedItem.clienteDistrito
        )
        .then(function (response) {
          me.barrios = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeDistritos() {
      this.getBarrios();
    },

    getDistritos() {
      let me = this;
      axios
        .get(
          "api/General/getDistritos?provincia=" +
          this.editedItem.clienteProvincia +
          "&canton=" +
          this.editedItem.clienteCanton
        )
        .then(function (response) {
          me.distritos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeCantones() {
      this.getDistritos();
    },

    getCantones() {
      let me = this;
      axios
        .get(
          "api/General/getCantones?provincia=" +
          this.editedItem.clienteProvincia
        )
        .then(function (response) {
          me.cantones = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeProvincia() {
      this.getCantones();
    },

    changeSucursal() {
      this.getTerminales();
      this.pagoInfo.sucursal = this.editedItem.sucursal;
      this.pagoInfo.terminal = this.editedItem.terminal;
    },

    getProvincias() {
      let me = this;
      axios
        .get("api/General/getProvincias")
        .then(function (response) {
          me.provincias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getMonedas() {
      let me = this;
      axios
        .get("api/General/getMonedas")
        .then(function (response) {
          me.monedas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    imprimir() {
      this.snackValue = false;
      axios
        .get(
          "api/Facturacion/getPdf?cia=" +
          this.strCia +
          "&clave=" +
          this.editedItem.clavehacienda
        )
        .then(function (response) {
          if (response.data) {
            console.log(response.data);
            window.open(response.data + ".pdf", "_blank");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getClientePOS() {
      this.snackValue = false;
      let me = this;

      me.showNewData = false;
      axios
        .get(
          "api/Clientes/getClientePOS?cia=" +
          this.strCia
        )
        .then(function (response) {
          me.cliente = response.data;
          me.showNewData = false;
          me.dialog = false;
          me.dialogArticulos = false;
          me.dalogArticuloError = false;
          me.editedItem.clienteCod = me.cliente.codigo;
          me.editedItem.clienteNombre = me.cliente.nombre;
          me.editedItem.clientecorreo = me.cliente.correo;
          me.editedItem.clienteCedula = me.cliente.cedula;
          me.editedItem.clienteAreaTel = me.cliente.areaTel;
          me.editedItem.clienteTelefono = me.cliente.telefono;
          me.editedItem.clienteNombreComercial = me.cliente.nombreComercial;
          me.getProvincias();
          me.editedItem.clienteProvincia = me.cliente.provincia;
          me.getCantones();
          me.editedItem.clienteCanton = me.cliente.canton;
          me.getDistritos();
          me.editedItem.clienteDistrito = me.cliente.distrito;
          me.getBarrios();
          me.editedItem.clienteBarrio = me.cliente.barrio;
          me.editedItem.clienteDireccion = me.cliente.direccion;
          me.editedItem.clienteTipoId = me.cliente.tipoId;
        })
        .catch(function (error) {
          console.log(error);
        });

    },

    BuscarClienteCodigo() {
      this.snackValue = false;
      let me = this;
      if (me.editedItem.clienteCod !== "") {
        me.showNewData = false;
        axios
          .get(
            "api/Clientes/getCliente?cia=" +
            this.strCia +
            "&codigo=" +
            this.editedItem.clienteCod
          )
          .then(function (response) {
            me.cliente = response.data;
            me.showNewData = false;
            me.dialog = false;
            me.dialogArticulos = false;
            me.dalogArticuloError = false;
            me.editedItem.clienteCod = me.cliente.codigo;
            me.editedItem.clienteNombre = me.cliente.nombre;
            me.editedItem.clientecorreo = me.cliente.correo;
            me.editedItem.clienteCedula = me.cliente.cedula;
            me.editedItem.clienteAreaTel = me.cliente.areaTel;
            me.editedItem.clienteTelefono = me.cliente.telefono;
            me.editedItem.clienteNombreComercial = me.cliente.nombreComercial;
            me.getProvincias();
            me.editedItem.clienteProvincia = me.cliente.provincia;
            me.getCantones();
            me.editedItem.clienteCanton = me.cliente.canton;
            me.getDistritos();
            me.editedItem.clienteDistrito = me.cliente.distrito;
            me.getBarrios();
            me.editedItem.clienteBarrio = me.cliente.barrio;
            me.editedItem.clienteDireccion = me.cliente.direccion;
            me.editedItem.clienteTipoId = me.cliente.tipoId;
            me.editedItem.clienteEsReceptor = me.cliente.esReceptor || false;
            me.editedItem.cedulaReceptor = me.cliente.cedula || "";
            me.forzarFactura = me.esSimplificado && (me.cliente.esReceptor || false);
            me.aplicarActividadCliente(me.cliente);
            me.getCodigoSegunCliente();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    BuscarClienteCedula() {
      this.snackValue = false;
      let me = this;
      if (me.editedItem.clienteCedula !== "") {
        me.showNewData = false;
        axios
          .get(
            "api/Clientes/getCliente?cia=" +
            this.strCia +
            "&cedula=" +
            this.editedItem.clienteCedula
          )
          .then(function (response) {
            me.cliente = response.data;
            me.showNewData = false;
            me.dialog = false;
            me.dialogArticulos = false;
            me.dalogArticuloError = false;
            me.editedItem.clienteCod = me.cliente.codigo;
            me.editedItem.clienteNombre = me.cliente.nombre;
            me.editedItem.clientecorreo = me.cliente.correo;
            me.editedItem.clienteCedula = me.cliente.cedula;
            me.editedItem.clienteAreaTel = me.cliente.areaTel;
            me.editedItem.clienteTelefono = me.cliente.telefono;
            me.editedItem.clienteNombreComercial = me.cliente.nombreComercial;
            me.getProvincias();
            me.editedItem.clienteProvincia = me.cliente.provincia;
            me.getCantones();
            me.editedItem.clienteCanton = me.cliente.canton;
            me.getDistritos();
            me.editedItem.clienteDistrito = me.cliente.distrito;
            me.getBarrios();
            me.editedItem.clienteBarrio = me.cliente.barrio;
            me.editedItem.clienteDireccion = me.cliente.direccion;
            me.editedItem.clienteTipoId = me.cliente.tipoId;
            me.editedItem.clienteEsReceptor = me.cliente.esReceptor || false;
            me.editedItem.cedulaReceptor = me.cliente.cedula || "";
            me.forzarFactura = me.esSimplificado && (me.cliente.esReceptor || false);
            me.aplicarActividadCliente(me.cliente);
            me.getCodigoSegunCliente();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    getTiposIdentificacion() {
      axios.get("api/General/getTiposIdentificacion").then(res => { this.tiposIdentificacion = res.data; });
    },

    abrirNuevoCliente() {
      this.nuevoCliente = {
        codigo: "", nombre: "", nombreComercial: "", moneda: "CRC",
        provincia: "", canton: "", distrito: "", barrio: "", direccion: "",
        esReceptor: false, correo: "", tipoId: "",
        areaTel: "506", telefono: "88888888", cedula: "", cia: "",
        esExonerado: false, exoTipo: "", exoNumDocumento: "",
        exoNomInstitucion: "", exoFecha: new Date().toISOString().substr(0, 10), exoPorcentaje: 0,
      };
      this.ncCantones = [];
      this.ncDistritos = [];
      this.ncActividades = [];
      this.ncActividadDefecto = null;
      this.getProvincias();
      this.dialogNuevoCliente = true;
    },

    ncGetCantones() {
      this.nuevoCliente.canton = "";
      this.nuevoCliente.distrito = "";
      this.nuevoCliente.direccion = "";
      this.ncDistritos = [];
      axios.get("api/General/getCantones?provincia=" + this.nuevoCliente.provincia)
        .then(res => { this.ncCantones = res.data; });
    },

    ncGetDistritos() {
      this.nuevoCliente.distrito = "";
      this.nuevoCliente.direccion = "";
      axios.get("api/General/getDistritos?provincia=" + this.nuevoCliente.provincia + "&canton=" + this.nuevoCliente.canton)
        .then(res => { this.ncDistritos = res.data; });
    },

    ncActualizarDireccion() {
      const prov = this.provincias.find(p => p.pr_codigo === this.nuevoCliente.provincia);
      const cant = this.ncCantones.find(c => c.ct_codigo === this.nuevoCliente.canton);
      const dist = this.ncDistritos.find(d => d.dt_codigo === this.nuevoCliente.distrito);
      const partes = [prov && prov.pr_nombre, cant && cant.ct_nombre, dist && dist.dt_nombre].filter(Boolean);
      if (partes.length) this.nuevoCliente.direccion = partes.join(", ");
    },

    ncMarcarDefecto(act) {
      this.ncActividades.forEach(a => { a.esDefecto = a.codigo === act.codigo; });
    },

    getHaciendaNuevoCliente() {
      if (!this.nuevoCliente.cedula) return;
      let me = this;
      me.nuevoClienteHaciendaLoading = true;
      axios.get("https://api.hacienda.go.cr/fe/ae?identificacion=" + me.nuevoCliente.cedula)
        .then(res => {
          const d = res.data;
          if (d.nombre) { me.nuevoCliente.nombre = d.nombre; me.nuevoCliente.nombreComercial = d.nombre; }
          if (d.tipoIdentificacion) me.nuevoCliente.tipoId = d.tipoIdentificacion;
          if (d.situacion && d.situacion.estado && d.situacion.estado.toLowerCase().includes("inscrito")) {
            me.nuevoCliente.esReceptor = true;
            me.nuevoCliente.areaTel = "506";
          }
          if (d.actividades && d.actividades.length > 0) {
            me.ncActividades = d.actividades.map((a, i) => ({
              codigo: a.codigo,
              descripcion: a.descripcion,
              estado: a.estado || "Activo",
              esDefecto: i === 0,
            }));
            me.ncActividadDefecto = me.ncActividades[0].codigo;
          }
        })
        .catch(() => {})
        .finally(() => { me.nuevoClienteHaciendaLoading = false; });
    },

    guardarNuevoCliente() {
      if (!this.nuevoCliente.nombre) { this.snackText = "El nombre es requerido"; this.snackValue = true; return; }
      let me = this;
      me.nuevoClienteLoading = true;
      axios.get("api/Clientes/getCodigoCliente?cia=" + me.strCia).then(res => {
        me.nuevoCliente.codigo = res.data;
        me.nuevoCliente.cia = me.strCia;
        me.nuevoCliente.actividades = me.ncActividades;
        axios.post("api/Clientes/insertClientes", me.nuevoCliente).then(() => {
          // Auto-seleccionar en la venta activa
          me.editedItem.clienteCod = me.nuevoCliente.codigo;
          me.editedItem.clienteNombre = me.nuevoCliente.nombre;
          me.editedItem.clientecorreo = me.nuevoCliente.correo;
          me.editedItem.clienteCedula = me.nuevoCliente.cedula;
          me.editedItem.clienteAreaTel = me.nuevoCliente.areaTel;
          me.editedItem.clienteTelefono = me.nuevoCliente.telefono;
          me.editedItem.clienteNombreComercial = me.nuevoCliente.nombreComercial;
          me.editedItem.clienteEsReceptor = me.nuevoCliente.esReceptor || false;
          me.editedItem.cedulaReceptor = me.nuevoCliente.esReceptor ? (me.nuevoCliente.cedula || "") : "";
          me.forzarFactura = me.esSimplificado && (me.nuevoCliente.esReceptor || false);
          me.aplicarActividadCliente(me.nuevoCliente);
          me.getCodigoSegunCliente();
          me.dialogNuevoCliente = false;
          me.snackText = "Cliente creado y seleccionado";
          me.snackValue = true;
        }).catch(() => { me.snackText = "Error al crear el cliente"; me.snackValue = true; })
          .finally(() => { me.nuevoClienteLoading = false; });
      }).catch(() => { me.nuevoClienteLoading = false; });
    },

    mostrarBuscarClientes() {
      this.snackValue = false;
      this.dialog = true;
      this.showNewData = true;
      this.cancelarValid = true;
    },

    mostrarBuscarArticulos() {
      this.snackValue = false;
      this.dialogArticulos = false;
      this.dialogBuscarArticulos = true;
      this.showNewDataArti = true;
      this.cancelarValid = true;
    },

    // getClienteHacienda() {
    //   let me = this;
    //   axios
    //     .get(
    //       "https://api.hacienda.go.cr/fe/ae?identificacion=" +
    //         me.editedItem.cedula
    //     )
    //     .then(function (response) {
    //       me.clienteHacienda = response.data;
    //       me.editedItem.nombre = me.clienteHacienda.nombre;
    //       me.editedItem.nombreComercial = me.clienteHacienda.nombre;
    //       me.editedItem.tipoId = me.clienteHacienda.tipoIdentificacion;

    //       if (me.clienteHacienda.situacion.estado === "Inscrito") {
    //         me.editedItem.esProd = true;
    //         me.editedItem.areaTel = "506";
    //       } else {
    //         me.editedItem.esProd = false;
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },

    changeMonedas() {
      if (this.editedItem.moneda === "USD") {
        this.getTipoCambio();
      }
      if (this.editedItem.moneda === "CRC") {
        this.editedItem.tipoCambio = 0;
      }
    },

    changeValueComponent() {
      this.snackValue = false;
    },

    getTipoCambio() {
      let me = this;
      axios
        .get(
          "https://apis.gometa.org/tdc/tdc.json?fbclid=IwAR0ye7K1k---y1DMcYsWN7AMSpQAB_LPTcbQnSDY72FrnffmeR_zfDfYiO4",
          { crossdomain: true }
        )
        .then(function (response) {
          me.tipoCambio = response.data;
          me.editedItem.tipoCambio = me.tipoCambio.venta;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItem(item) {
      this.snackValue = false;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.getModeloComprobante();
      this.editedItem.nombreTabla = "Tiquetes";
      this.getCia();
      this.getMonedas();
      this.getActividades();
      this.getCondicionVenta();
      this.getMedioPago();
      this.getSucursales();
      this.changeProvincia();
      this.changeCantones();
      this.changeDistritos();
      this.tab2 = 1;
      this.cancelarValid = false;

      if (
        this.editedItem.estadoHacienda === "ACEPTADO" ||
        this.editedItem.estadoHacienda === "RECHAZADO"
      ) {
        this.imprimirValid = true;
        this.reenviarValid = true;
        this.verPDF = true;
        this.verXMLFirmado = true;
        this.verXMLRespuesta = true;
      } else {
        this.imprimirValid = false;
        this.reenviarValid = false;
        this.verPDF = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
      }

      this.guardarValid = false;
      this.incluirValid = true;
      this.panel = [0];
      this.panelResumen = [0];
      if (this.editedItem.estadoHacienda === "PROCESANDO") {
        this.consultarEstadoValid = true;
      }
    },

    detalleEditItem(item) {
      if (this.guardarValid) {
        this.detalleEditedIndex = this.lineasDetalle.indexOf(item);
        this.detalleEditedItem = Object.assign({}, item);

        console.log(this.detalleEditedIndex);
        console.log(this.detalleEditedItem.articulo);

        // this.editedIndex = this.items.indexOf(item);
        // this.editedItem = Object.assign({}, item);

        this.dialogArticulos = true;
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.detalleEditedIndex = -1;
      });
    },

    deleteItemConfirm() {
      if (this.guardarValid) {
        this.lineasDetalle.splice(this.detalleEditedIndex, 1);
        this.closeDelete();

        let me = this;

        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;
            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto
            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
            //me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      }
    },

    consultarEstadoHacienda() {
      this.snackValue = false;
      this.visibleProgress = true;
      let me = this;

      this.comprobante = this.editedItem;

      axios
        .post("api/Facturacion/obtenerRespuestaHacienda", this.comprobante)
        .then(function (response) {
          me.respuestaHacienda = response.data;
          me.editedItem.estadoHacienda = me.respuestaHacienda.eInvoiceStatus;
          me.editedItem.mensajeHacienda = me.respuestaHacienda.details;
          me.visibleProgress = false;

          if (me.editedItem.estadoHacienda !== "PROCESANDO") {
            me.consultarEstadoValid = false;
          }

          if (
            me.editedItem.estadoHacienda === "ACEPTADO" ||
            me.editedItem.estadoHacienda === "RECHAZADO"
          ) {
            me.imprimirValid = true;
            me.reenviarValid = true;
            me.verPDF = true;
            me.verXMLFirmado = true;
            me.verXMLRespuesta = true;
          } else {
            me.imprimirValid = false;
            me.reenviarValid = false;
            me.verPDF = false;
            me.verXMLFirmado = false;
            me.verXMLRespuesta = false;
          }
          me.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    reenviarCorreo() {
      this.snackValue = false;
      let me = this;

      this.comprobante = this.editedItem;

      axios
        .post("api/Facturacion/reenviarCorreo", this.comprobante)
        .then(function (response) {
          me.snackText = response.data;
          me.snackValue = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getReport() {
      this.snackValue = false;
      axios
        .get(
          "api/Facturacion/getPdf?cia=" +
          this.strCia +
          "&clave=" +
          this.editedItem.clavehacienda
        )
        .then(function (response) {
          if (response.data) {
            console.log(response.data);
            window.open(response.data + ".pdf", "_blank");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getXMLFirmado() {
      this.snackValue = false;
      axios
        .get(
          "api/Facturacion/getPdf?cia=" +
          this.strCia +
          "&clave=" +
          this.editedItem.clavehacienda
        )
        .then(function (response) {
          if (response.data) {
            console.log(response.data);
            window.open(response.data + "_Signed.xml", "_blank");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getXMLRespuesta() {
      this.snackValue = false;
      axios
        .get(
          "api/Facturacion/getPdf?cia=" +
          this.strCia +
          "&clave=" +
          this.editedItem.clavehacienda
        )
        .then(function (response) {
          if (response.data) {
            console.log(response.data);
            window.open(response.data + "_Response.xml", "_blank");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getModeloComprobante() {
      this.snackValue = false;
      let me = this;

      axios
        .get(
          "api/Facturacion/getModeloComprobante?cia=" +
          this.strCia +
          "&clave=" +
          this.editedItem.clavehacienda +
          "&docNombre=Tiquetes"
        )
        .then(function (response) {
          me.modelFactura = response.data;

          me.editedItem = me.modelFactura.comprobante;
          me.lineasDetalle = me.modelFactura.comprobanteDetalle;
          me.fecha = me.editedItem.fechaString;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getOpcionesSistemaCia() {
      let me = this;
      axios
        .get("api/General/getOpcionesSistemaCia?cia=" + this.strCia)
        .then(function (response) {
          me.opcionesSistemaCia = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getParametrosCia() {
      let me = this;
      axios.get("api/General/getParametros?cia=" + this.strCia)
        .then(function (response) {
          const simplificado = response.data.find(p => p.nombre === 'Simplificado');
          me.esSimplificado = simplificado ? (simplificado.valor || '').toLowerCase() === 'true' : false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async save() {
      this.snackValue = false;
      for (const opc of this.opcionesSistemaCia) {
        if (opc.opcionId === "pagos_sinpe") {
          if (opc.valor === "true") {
            this.dialogSinpe = true;
            this.showNewData = true;
          }
        }
      }
      let me = this;
      this.visibleProgress = true;
      this.editedItem.fecha = new Date();
      this.editedItem.fechaHacienda = new Date();
      this.editedItem.cia = this.strCia;
      this.editedItem.usuario = this.user.id;

      // PERSISTENCIA FINANCIERA BILINGÜE 💵⚓
      this.editedItem.TDC_Factura = (this.cajaPOS && this.cajaPOS.tdc) ? this.cajaPOS.tdc : 0;
      if (this.cobrarDatos.pagoEnUSD && this.cobrarDatos.pagaConUSD > 0) {
        // Guardamos el neto en dólares q entró a la gaveta (Pago - Vuelto)
        this.editedItem.MontoEfectivoUSD = parseFloat(this.cobrarDatos.pagaConUSD) - (this.cobrarDatos.vueltoUSD || 0);
      } else {
        this.editedItem.MontoEfectivoUSD = 0;
      }

      // 🆕 Pago Mixto: mapear montos al editedItem
      this.editedItem.PagoEfectivo  = parseFloat(this.pagosMixtos.efectivo)  || 0;
      this.editedItem.PagoTarjeta   = parseFloat(this.pagosMixtos.tarjeta)   || 0;
      this.editedItem.PagoSinpe     = parseFloat(this.pagosMixtos.sinpe)     || 0;
      this.editedItem.PagoTransDepo = parseFloat(this.pagosMixtos.transDepo) || 0;
      this.editedItem.PagoCheque    = parseFloat(this.pagosMixtos.cheque)    || 0;

      // Construir nota de referencia de pago mixto en observación
      const metodosTxt = [];
      if (this.editedItem.PagoEfectivo  > 0) metodosTxt.push(`Ef:₡${this.editedItem.PagoEfectivo.toLocaleString()}`);
      if (this.editedItem.PagoTarjeta   > 0) metodosTxt.push(`Tarj:₡${this.editedItem.PagoTarjeta.toLocaleString()}`);
      if (this.editedItem.PagoSinpe     > 0) metodosTxt.push(`Sinpe:₡${this.editedItem.PagoSinpe.toLocaleString()}`);
      if (this.editedItem.PagoTransDepo > 0) metodosTxt.push(`Trans:₡${this.editedItem.PagoTransDepo.toLocaleString()}`);
      if (this.editedItem.PagoCheque    > 0) metodosTxt.push(`Cheq:₡${this.editedItem.PagoCheque.toLocaleString()}`);
      if (metodosTxt.length > 1) {
        const refMixto = ` [Mixto: ${metodosTxt.join(' + ')}]`;
        if (!(this.editedItem.observacion || '').includes('[Mixto:')) {
          this.editedItem.observacion = (this.editedItem.observacion || '') + refMixto;
        }
      }

      if (!this.editedItem.codigoActividad && this.ciaItem) {
        this.editedItem.codigoActividad = this.ciaItem.codigoActividad || "";
      }
      if (!this.editedItem.clienteTipoId && this.editedItem.clienteCedula) {
        this.editedItem.clienteTipoId = this.derivarTipoId(this.editedItem.clienteCedula);
      }

      // REFERENCIA DE PAGO (Tarjeta/Sinpe) 💳📱
      let refPago = "";
      if (this.paymentMethod === 'card' && this.cobrarDatos.ultimos4) {
        refPago = ` [Tarj: ${this.cobrarDatos.ultimos4}]`;
      } else if (this.paymentMethod === 'sinpe' && this.cobrarDatos.refSinpe) {
        refPago = ` [Sinpe: ${this.cobrarDatos.refSinpe}]`;
      }
      if (refPago && !(this.editedItem.observacion || "").includes(refPago)) {
        this.editedItem.observacion = (this.editedItem.observacion || "") + refPago;
      }

      const tipo = (this.editedIndex > -1) ? (this.editedItem.tipoFact || this.editedItem.TipoFact) : (this.esFactura ? "01" : "04");
      const tabla = (this.editedIndex > -1) ? (this.editedItem.nombreTabla || this.editedItem.NombreTabla) : (this.esFactura ? "Facturas" : "Tiquetes");

      this.editedItem.tipoFact = tipo;
      this.editedItem.TipoFact = tipo;
      this.editedItem.TipoDoc = tipo;
      
      this.editedItem.nombreTabla = tabla;
      this.editedItem.NombreTabla = tabla;
      this.editedItem.DocNombre = tabla;

      // 🔄 Sincronización Detalle-Cabecera y Dual Case Fix para Líneas
      this.lineasDetalle.forEach((linea, index) => {
        linea.cia = this.editedItem.cia;
        linea.Cia = this.editedItem.cia;
        linea.factura = this.editedItem.codigoFact;
        linea.Factura = this.editedItem.codigoFact;
        linea.tipoFact = tipo;
        linea.TipoFact = tipo;
        linea.numLinea = index + 1;
        linea.NumLinea = index + 1;
      });

      this.modelFactura.comprobante = this.editedItem;
      this.modelFactura.comprobanteDetalle = this.lineasDetalle;
      this.pagoInfo.total = this.editedItem.totalComprobante;

      try {
        let response = await axios.post("api/Facturacion/saveComprobantePOS", this.modelFactura);

        if (response && response.data) {
          me.resultadoGuardarTiquete = response.data;
          me.getCodigoSegunCliente();
          
          this.cancelarValid = false;
          this.guardarValid = false;
          this.incluirValid = true;
          this.snackValue = false;
          this.btnAgregarArti = false;
          this.btnAgregarCliente = false;
          this.focusInput();
          this.cerrar();
          this.incluir();
        }
      } catch (error) {
        console.error("Error al guardar en el POS:", error);
        this.snackText = "Error al procesar la venta. Verifique su conexión.";
        this.snackValue = true;
      } finally {
        this.visibleProgress = false;
      }
    },

    async saveReport(action) {
      this.snackValue = false;
      for (const opc of this.opcionesSistemaCia) {
        if (opc.opcionId === "pagos_sinpe") {
          if (opc.valor === "true") {
            this.dialogSinpe = true;
            this.showNewData = true;
          }
        }
      }
      // Safari bloquea window.open() después de un await (pierde el contexto del gesto).
      // Se abre la ventana ANTES del await para conservarlo.
      let printWindow = null;
      if (action === 'print') {
        printWindow = window.open('', 'print_preview');
      }
      let me = this;
      this.visibleProgress = true;
      this.editedItem.fecha = new Date();
      this.editedItem.fechaHacienda = new Date();
      this.editedItem.cia = this.strCia;
      this.editedItem.usuario = this.user.id;
      
      // PERSISTENCIA FINANCIERA BILINGÜE 💵⚓
      this.editedItem.TDC_Factura = (this.cajaPOS && this.cajaPOS.tdc) ? this.cajaPOS.tdc : 0;
      if (this.cobrarDatos.pagoEnUSD && this.cobrarDatos.pagaConUSD > 0) {
        this.editedItem.MontoEfectivoUSD = parseFloat(this.cobrarDatos.pagaConUSD) - (this.cobrarDatos.vueltoUSD || 0);
      } else {
        this.editedItem.MontoEfectivoUSD = 0;
      }

      // 🆕 Pago Mixto: mapear montos al editedItem
      this.editedItem.PagoEfectivo  = parseFloat(this.pagosMixtos.efectivo)  || 0;
      this.editedItem.PagoTarjeta   = parseFloat(this.pagosMixtos.tarjeta)   || 0;
      this.editedItem.PagoSinpe     = parseFloat(this.pagosMixtos.sinpe)     || 0;
      this.editedItem.PagoTransDepo = parseFloat(this.pagosMixtos.transDepo) || 0;
      this.editedItem.PagoCheque    = parseFloat(this.pagosMixtos.cheque)    || 0;

      // Referencia mixta en observación
      const metodosTxt2 = [];
      if (this.editedItem.PagoEfectivo  > 0) metodosTxt2.push(`Ef:₡${this.editedItem.PagoEfectivo.toLocaleString()}`);
      if (this.editedItem.PagoTarjeta   > 0) metodosTxt2.push(`Tarj:₡${this.editedItem.PagoTarjeta.toLocaleString()}`);
      if (this.editedItem.PagoSinpe     > 0) metodosTxt2.push(`Sinpe:₡${this.editedItem.PagoSinpe.toLocaleString()}`);
      if (this.editedItem.PagoTransDepo > 0) metodosTxt2.push(`Trans:₡${this.editedItem.PagoTransDepo.toLocaleString()}`);
      if (this.editedItem.PagoCheque    > 0) metodosTxt2.push(`Cheq:₡${this.editedItem.PagoCheque.toLocaleString()}`);
      if (metodosTxt2.length > 1) {
        const refMixto2 = ` [Mixto: ${metodosTxt2.join(' + ')}]`;
        if (!(this.editedItem.observacion || '').includes('[Mixto:')) {
          this.editedItem.observacion = (this.editedItem.observacion || '') + refMixto2;
        }
      }

      // codigoActividad se resetea al cerrar/incluir; lo restauramos desde ciaItem
      if (!this.editedItem.codigoActividad && this.ciaItem) {
        this.editedItem.codigoActividad = this.ciaItem.codigoActividad || "";
      }
      // clienteTipoId puede no venir del stored proc; lo derivamos de la cédula como fallback
      if (!this.editedItem.clienteTipoId && this.editedItem.clienteCedula) {
        this.editedItem.clienteTipoId = this.derivarTipoId(this.editedItem.clienteCedula);
      }

      // REFERENCIA DE PAGO (Tarjeta/Sinpe) 💳📱
      let refPago2 = "";
      if (this.paymentMethod === 'card' && this.cobrarDatos.ultimos4) {
        refPago2 = ` [Tarj: ${this.cobrarDatos.ultimos4}]`;
      } else if (this.paymentMethod === 'sinpe' && this.cobrarDatos.refSinpe) {
        refPago2 = ` [Sinpe: ${this.cobrarDatos.refSinpe}]`;
      }
      if (refPago2 && !(this.editedItem.observacion || "").includes(refPago2)) {
        this.editedItem.observacion = (this.editedItem.observacion || "") + refPago2;
      }

      const tipo2 = (this.editedIndex > -1) ? (this.editedItem.tipoFact || this.editedItem.TipoFact) : (this.esFactura ? "01" : "04");
      const tabla2 = (this.editedIndex > -1) ? (this.editedItem.nombreTabla || this.editedItem.NombreTabla) : (this.esFactura ? "Facturas" : "Tiquetes");

      this.editedItem.tipoFact = tipo2;
      this.editedItem.TipoFact = tipo2;
      this.editedItem.TipoDoc = tipo2;
      
      this.editedItem.nombreTabla = tabla2;
      this.editedItem.NombreTabla = tabla2;
      this.editedItem.DocNombre = tabla2;

      // 🔄 Sincronización Detalle-Cabecera y Dual Case Fix para Líneas
      this.lineasDetalle.forEach((linea, index) => {
        linea.cia = this.editedItem.cia;
        linea.Cia = this.editedItem.cia;
        linea.factura = this.editedItem.codigoFact;
        linea.Factura = this.editedItem.codigoFact;
        linea.tipoFact = tipo2;
        linea.TipoFact = tipo2;
        linea.numLinea = index + 1;
        linea.NumLinea = index + 1;
      });

      this.modelFactura.comprobante = this.editedItem;
      this.modelFactura.comprobanteDetalle = this.lineasDetalle;
      this.pagoInfo.total = this.editedItem.totalComprobante;

      try {
        let response = await axios.post("api/Facturacion/saveComprobantePOS", this.modelFactura);

        if (response && response.data) {
          me.resultadoGuardarTiquete = response.data;
          // Asignar claves devueltas por el API para poder imprimirlas
          if (response.data.claveHacienda) {
            me.editedItem.clavehacienda = response.data.claveHacienda;
            me.editedItem.consHacReal = response.data.consecutivoHacienda;
          }
        }

        if (action === 'print') {
          me.generarTiqueteReport();
          me.ejecutarImpresion(printWindow);
        } else if (action === 'share') {
          me.generarTiqueteReport();
          me.ejecutarCompartir();
        }

        me.getCodigoSegunCliente();
        me.focusInput();
      } catch (error) {
        console.log(error);
      } finally {
        this.visibleProgress = false;
        this.cancelarValid = false;
        this.guardarValid = false;
        this.incluirValid = true;
        this.snackValue = false;
        this.btnAgregarArti = false;
        this.btnAgregarCliente = false;
        this.focusInput();
        this.cerrar();
        this.dialogReport = false;
      }
    },

    scrollToBottom() {
      let element = document.getElementById("yourID");
      element.scrollIntoView(false);
    },

    saveDetalleArticulo2() {

      //console.log(this.articulo.codigo);
      console.log(this.detalleEditedItem.cantidad);

      if (this.detalleEditedIndex > -1) {
        Object.assign(
          this.lineasDetalle[this.detalleEditedIndex],
          this.detalleEditedItem
        );
      } else {
        this.lineasDetalle.push(this.detalleEditedItem);
      }
      this.close();

      let me = this;
      if (this.detalleEditedIndex > -1) {
        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;
            //me.lineasDetalle.reverse();
            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto

            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
            me.focusInput();
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;
            //me.lineasDetalle.reverse();
            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto
            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
            me.focusInput();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      this.cancelarValid = true;
      this.imprimirValid = false;
      this.reenviarValid = false;
      this.verPDF = false;
      this.verXMLFirmado = false;
      this.verXMLRespuesta = false;
      this.guardarValid = true;
      this.incluirValid = false;
      this.snackValue = false;
      this.panelResumen = [0];
      this.consultarEstadoValid = false;
      this.changeValueComponent();
      this.setFocus();
    },

    saveDetalleArticulo() {
      if (this.detalleEditedIndex > -1) {
        // Modo edición: actualizar la línea existente en su posición
        Object.assign(this.lineasDetalle[this.detalleEditedIndex], this.detalleEditedItem);
      } else if (this.articulo.esGenerico) {
        // Artículo genérico: siempre agregar nueva línea
        this.lineasDetalle.unshift(this.detalleEditedItem);
      } else {
        // Artículo normal: acumular si ya existe, sino agregar
        const existingItem = this.lineasDetalle.find(
          (item) => item.articulo === this.articulo.codigo
        );
        if (existingItem) {
          existingItem.cantidad++;
        } else {
          this.lineasDetalle.unshift(this.detalleEditedItem);
        }
      }
      this.close();

      let me = this;
      if (this.detalleEditedIndex > -1) {
        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;
            //me.lineasDetalle.reverse();
            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto

            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
            me.focusInput();
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        axios
          .post(
            "api/Facturacion/realizarCalculosComprobante",
            this.lineasDetalle
          )
          .then(function (response) {
            me.lineasDetalle = response.data.comprobanteDetalle;
            //me.lineasDetalle.reverse();
            me.totales = response.data.comprobante;
            me.editedItem.totalIVADevuelto = 0; //validar esto
            me.editedItem.subTotal = me.totales.subtotal;
            me.editedItem.totalDescuentos = me.totales.totalDescuentos;
            me.editedItem.totalImpuesto = me.totales.totalImpuesto;
            me.editedItem.totalIva1 = me.totales.totalIva1;
            me.editedItem.totalIva2 = me.totales.totalIva2;
            me.editedItem.totalIva4 = me.totales.totalIva4;
            me.editedItem.totalIva13 = me.totales.totalIva13;
            me.editedItem.totalComprobante = me.totales.totalComprobante;

            me.editedItem.totalServGravados = me.totales.totalServGravados;
            me.editedItem.totalServExentos = me.totales.totalServExentos;
            me.editedItem.totalServExonerado = me.totales.totalServExonerado;
            me.editedItem.totalMercanciasGravadas =
              me.totales.totalMercanciasGravadas;
            me.editedItem.totalMercanciasExentas =
              me.totales.totalMercanciasExentas;
            me.editedItem.totalMercExonerada = me.totales.totalMercExonerada;
            me.editedItem.totalGravado = me.totales.totalGravado;
            me.editedItem.totalExento = me.totales.totalExento;
            me.editedItem.totalExonerado = me.totales.totalExonerado;
            me.editedItem.totalVenta = me.totales.totalVenta;
            me.editedItem.totalVentaNeta = me.totales.totalVentaNeta;
            me.editedItem.totalIVADevuelto = me.totales.totalIVADevuelto;
            me.editedItem.totalOtrosCargos = me.totales.totalOtrosCargos;
            me.editedItem.totalIva13 = me.totales.totalIva13;

            me.editedItem.totalIVADevueltoStr = me.totales.totalIVADevueltoStr; //validar esto
            me.editedItem.totalIva1Str = me.totales.totalIva1Str;
            me.editedItem.totalIva2Str = me.totales.totalIva2Str;
            me.editedItem.totalIva4Str = me.totales.totalIva4Str;
            me.editedItem.totalIva13Str = me.totales.totalIva13Str;
            me.editedItem.totalDescuentosStr = me.totales.totalDescuentosStr;
            me.editedItem.totalImpuestoStr = me.totales.totalImpuestoStr;
            me.editedItem.subtotalStr = me.totales.subtotalStr;
            me.editedItem.totalComprobanteStr = me.totales.totalComprobanteStr;
            me.focusInput();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      this.cancelarValid = true;
      this.imprimirValid = false;
      this.reenviarValid = false;
      this.verPDF = false;
      this.verXMLFirmado = false;
      this.verXMLRespuesta = false;
      this.guardarValid = true;
      this.incluirValid = false;
      this.snackValue = false;
      this.panelResumen = [0];
      this.consultarEstadoValid = false;
      this.changeValueComponent();
      this.setFocus();
    },

    close() {
      this.snackValue = false;
      this.dialogArticulos = false;
      this.dalogArticuloError = false;
      this.$nextTick(() => {
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.detalleEditedIndex = -1;
        this.focusInput();
      });
    },

    deleteItem(item) {
      if (this.guardarValid) {
        this.detalleEditedIndex = this.lineasDetalle.indexOf(item);
        this.detalleEditedItem = Object.assign({}, item);
        this.dialogDelete = true;
      }
    },

    closed() {
      this.snackValue = false;
      this.showNewData = false;
      this.showNewDataArti = false;
      this.dialog = false;
      //this.dialogReport = false;
      this.dialogArticulos = false;
      this.dialogSinpe = false;
      this.dialogBuscarArticulos = false;
      this.dalogArticuloError = false;
    },

    closed2() {
      this.dialogReport = false;
    },

    selected(value) {
      this.setFocus();
      this.focusInput();
      this.cliente = Object.assign({}, value);
      this.showNewData = false;
      this.dialog = false;
      this.dialogArticulos = false;
      this.dalogArticuloError = false;
      this.editedItem.clienteCod = this.cliente.codigo;
      this.editedItem.clienteNombre = this.cliente.nombre;
      this.editedItem.clientecorreo = this.cliente.correo;
      this.editedItem.clienteCedula = this.cliente.cedula;
      this.editedItem.clienteAreaTel = this.cliente.areaTel;
      this.editedItem.clienteTelefono = this.cliente.telefono;
      this.editedItem.clienteNombreComercial = this.cliente.nombreComercial;
      this.getProvincias();
      this.editedItem.clienteProvincia = this.cliente.provincia;
      this.getCantones();
      this.editedItem.clienteCanton = this.cliente.canton;
      this.getDistritos();
      this.editedItem.clienteDistrito = this.cliente.distrito;
      this.getBarrios();
      this.editedItem.clienteBarrio = this.cliente.barrio;
      this.editedItem.clienteDireccion = this.cliente.direccion;
      this.editedItem.clienteTipoId = this.cliente.tipoId;
      // Algunos campos pueden no venir del listado (depende del stored proc),
      // los obtenemos del endpoint de detalle que devuelve todos los campos.
      const me = this;
      axios.get("api/Clientes/getCliente?cia=" + me.strCia + "&codigo=" + me.cliente.codigo)
        .then(function (res) {
          if (res.data) {
            const c = res.data;
            me.editedItem.clienteTipoId    = c.tipoId    || me.editedItem.clienteTipoId;
            me.editedItem.clienteCedula    = c.cedula    || me.editedItem.clienteCedula;
            me.editedItem.clienteEsReceptor = c.esReceptor || false;
            // cedulaReceptor es requerido por Hacienda en Facturas Electrónicas
            me.editedItem.cedulaReceptor   = c.cedula    || "";
            me.forzarFactura = me.esSimplificado && (c.esReceptor || false);
            me.aplicarActividadCliente(c);
            me.getCodigoSegunCliente();
          }
        });
      this.btnAgregarArti = true;
      this.changeValueComponent();
      this.setFocus();
      this.focusInput();
    },

    selectedArticulos(value) {
      this.articulo = Object.assign({}, value);
      console.log("es generico");
      console.log(this.articulo.esGenerico);
      this.showNewDataArti = false;
      this.dialogBuscarArticulos = false;
      this.dialogArticulos = true;
      this.dalogArticuloError = false;
      this.detalleEditedItem.cia = this.strCia;
      this.detalleEditedItem.factura = this.editedItem.codigoFact;
      this.detalleEditedItem.tipoFact = this.esFactura ? "01" : "04";
      this.detalleEditedItem.numLinea = 0;
      this.detalleEditedItem.unidad = this.articulo.unidad;
      this.detalleEditedItem.descuento = 0;
      this.detalleEditedItem.totalLinea = 0;
      this.detalleEditedItem.sucursal = this.editedItem.sucursal;
      this.detalleEditedItem.terminal = this.editedItem.terminal;
      this.detalleEditedItem.tipoCodigo = "01";
      this.detalleEditedItem.unidadMedidaComercial = "M2";
      this.detalleEditedItem.impCodigo = this.articulo.codigoImp;
      this.detalleEditedItem.impCodigoTarifa = this.articulo.codigoTarifa;
      this.detalleEditedItem.impTarifa = this.articulo.tarifa;
      this.detalleEditedItem.porcDescuento = 0;
      this.detalleEditedItem.monto = this.articulo.monto;
      this.detalleEditedItem.descripcion = this.articulo.nombre;
      this.detalleEditedItem.cantidad = 1;
      this.detalleEditedItem.cabys = this.articulo.cabys;
      this.detalleEditedItem.articulo = this.articulo.codigo;
      this.detalleEditedItem.tipoCambio = this.editedItem.tipoCambio;
      this.detalleEditedItem.impuestosVentas = this.articulo.tarifa;
      this.detalleEditedItem.tipoProducto = this.articulo.tipoArt;
      this.detalleEditedItem.moneda = this.editedItem.moneda;
      this.detalleEditedItem.clienteCod = this.editedItem.clienteCod;
      this.detalleEditedItem.clienteCedula = this.editedItem.clienteCedula;
      this.changeValueComponent();
    },

    limpiar() {
      this.snackValue = false;
    },

    cancelarCobro() {
      this.dialogCobrar = false;
      this.$nextTick(() => {
        this.focusInput();
      });
    },

    cancelarInformacionAdicional() {
      this.dialogInformacionAdicional = false;
      this.$nextTick(() => {
        this.focusInput();
      });
    },

    cerrar() {
      this.changeValueComponent();
      this.snackValue = false;
      this.dialog = false;
      this.dialogArticulos = false;
      this.dialogCobrar = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.valid = false;
        this.cancelarValid = false;
        this.imprimirValid = false;
        this.reenviarValid = false;
        this.verPDF = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        this.guardarValid = false;
        this.incluirValid = true;
        this.consultarEstadoValid = false;
        this.panelResumen = [];
        this.panel = [];
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.lineasDetalle = [];
        this.btnAgregarArti = false;
        this.btnAgregarCliente = false;
        this.incluir();
        this.getClientePOS();
        this.getCodigoTiquete();
      });
    },

    onImageChange(ev) {
      this.tempFile = ev;
      this.editedItem.certificado = ev.name;
    },

    changePagaCon() {
      if (this.cobrarDatos.pagaCon > this.editedItem.totalComprobante) {
        this.cobrarDatos.vuelto = this.cobrarDatos.pagaCon - this.editedItem.totalComprobante;
      }
    },


    calcularConversionUSD() {
      if (!this.cobrarDatos.pagaConUSD || this.cobrarDatos.pagaConUSD <= 0) {
        this.cobrarDatos.pagaCon = "";
        this.cobrarDatos.vuelto = "";
        this.cobrarDatos.vueltoUSD = 0;
        return;
      }
      
      const tdc = (this.cajaPOS && this.cajaPOS.tdc) ? this.cajaPOS.tdc : 0;
      if (tdc > 0) {
        // Convertimos a colones para el proceso normal
        const pagaColones = (parseFloat(this.cobrarDatos.pagaConUSD) * tdc);
        this.cobrarDatos.pagaCon = pagaColones;
        
        // Calculamos el vuelto en dólares si el pago es mayor al total
        const totalDolares = this.editedItem.totalComprobante / tdc;
        if (parseFloat(this.cobrarDatos.pagaConUSD) > totalDolares) {
          this.cobrarDatos.vueltoUSD = (parseFloat(this.cobrarDatos.pagaConUSD) - totalDolares).toFixed(2);
        } else {
          this.cobrarDatos.vueltoUSD = 0;
        }

        this.changePagaCon();
      }
    },

    getCodigoTiquete() {
      let me = this;
      axios
        .get(
          "api/Facturacion/getComprobanteConsInterno?cia=" +
          this.strCia +
          "&docNombre=Tiquetes&tipoDoc=T"
        )
        .then(function (response) {
          me.editedItem.codigoFact = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCodigoFactura() {
      let me = this;
      axios
        .get(
          "api/Facturacion/getComprobanteConsInterno?cia=" +
          this.strCia +
          "&docNombre=Facturas&tipoDoc=F"
        )
        .then(function (response) {
          me.editedItem.codigoFact = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    aplicarActividadCliente(clienteData) {
      const cedulaCliente = clienteData ? clienteData.cedula : "";
      if (!cedulaCliente || !this.ciaItem.cedula) {
        this.clienteActividades = [];
        this.editedItem.clienteCodigoActividad = "";
        return;
      }
      const me = this;
      axios.get("api/Clientes/getActividadesByCliente?cedulaCia=" + me.ciaItem.cedula + "&cedulaCliente=" + cedulaCliente)
        .then(function(res) {
          const acts = res.data || [];
          me.clienteActividades = acts;
          const defecto = acts.find(a => a.esDefecto) || acts[0];
          me.editedItem.clienteCodigoActividad = defecto ? defecto.codigo : "";
        })
        .catch(function() {
          me.clienteActividades = [];
          me.editedItem.clienteCodigoActividad = "";
        });
    },

    getCodigoSegunCliente() {
      if (this.esFactura) {
        this.getCodigoFactura();
      } else {
        this.getCodigoTiquete();
      }
    },

    derivarTipoId(cedula) {
      if (!cedula) return "";
      const c = cedula.toString().replace(/\D/g, "");
      if (c.length === 9)  return "01"; // Cédula Física
      if (c.length === 10) return "02"; // Cédula Jurídica
      if (c.length >= 11)  return "03"; // DIMEX
      return "02";
    },

    getFechaActual() {
      let me = this;
      axios
        .get("api/Facturacion/getFechaActualString")
        .then(function (response) {
          me.fecha = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validarLicencia() {
      let me = this;
      axios
        .get("api/General/licenciaValidar?cia=" + this.strCia)
        .then(function (response) {
          me.licenciaValida = response.data;
          if (me.licenciaValida.valido) {
            me.incluir();
          } else {
            me.snackText = me.licenciaValida.motivo;
            me.snackValue = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // getCodigoTiquete() {
    //   let me = this;
    //   axios
    //     .get(
    //       "api/Facturacion/getComprobanteConsInterno?cia=" +
    //       this.strCia +
    //       "&docNombre=Tiquetes&tipoDoc=T"
    //     )
    //     .then(function (response) {
    //       me.editedItem.codigoFact = response.data;
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },

    incluir() {
      this.snackValue = false;
      this.forzarFactura = false;
      this.clienteActividades = [];
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.getCodigoTiquete();
        this.getCodigoTiquete();
        this.cancelarValid = true;
        this.imprimirValid = false;
        this.reenviarValid = false;
        this.verPDF = false;
        this.verXMLFirmado = false;
        this.verXMLRespuesta = false;
        this.guardarValid = true;
        this.incluirValid = false;
        this.consultarEstadoValid = false;
        this.getCia();
        this.getMonedas();
        this.getActividades();
        this.getCondicionVenta();
        this.getMedioPago();
        this.getSucursales();
        this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
        this.lineasDetalle = [];
        this.editedItem.estadoHacienda = "PENDIENTE";
        this.panel = [0];
        this.btnAgregarCliente = true;
        this.getFechaActual();
        this.editedItem.clienteCod = "";
        this.BuscarClienteCodigo();
        this.btnAgregarArti = true;
      });
    },

    generarTiqueteReport() {
      const fechaObj = new Date();
      const fecha = fechaObj.toLocaleDateString();
      const hora = fechaObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const tituloTiquete = this.esFactura
        ? (this.editedItem.clavehacienda ? "Factura Electrónica" : "Factura")
        : (this.editedItem.clavehacienda ? "Tiquete Electrónico" : "Tiquete");
      
      let productosHTML = '';
      this.lineasDetalle.forEach(p => {
        const symbol = this.editedItem.moneda === 'USD' ? '$' : '₡';
        const cabys = p.cabys ? p.cabys + " - " : "";
        productosHTML += `
          <div class="product-row">
            <span class="product-name">${cabys}${p.descripcion}</span>
            <div class="flex-row">
              <span>${p.cantidad} x ${p.precioUnitario || p.monto}</span>
              <span>${symbol}${p.totalLinea}</span>
            </div>
          </div>
        `;
      });

      this.tiqueteInfo.idTiquete = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Tiquete</title>
  <style>
    body {
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 13px;
      color: #000;
      margin: 0;
      padding: 0;
    }
    .ticket {
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
      padding: 10px;
    }
    .text-center { text-align: center; }
    .font-bold { font-weight: bold; }
    .title { font-size: 18px; font-weight: bold; margin-bottom: 5px; text-transform: uppercase; }
    .subtitle { font-size: 14px; font-weight: bold; margin-bottom: 2px; text-transform: uppercase; }
    .info { font-size: 12px; line-height: 1.2; }
    hr {
      border: 0;
      border-top: 2px solid #000;
      margin: 6px 0;
    }
    .flex-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
    .details p {
      margin: 3px 0;
      font-size: 12px;
    }
    .clave-box {
      font-size: 11px;
      word-break: break-all;
      margin: 4px 0;
    }
    .products {
      width: 100%;
      font-size: 12px;
      margin-top: 5px;
    }
    .product-row {
      margin-bottom: 6px;
    }
    .product-name {
      display: block;
      margin-bottom: 2px;
    }
    .totals {
      margin-top: 5px;
      font-size: 13px;
    }
    .totals .flex-row {
      margin: 3px 0;
    }
    .grand-total {
      font-size: 18px;
      font-weight: bold;
      margin-top: 6px;
      margin-bottom: 6px;
    }
    .footer {
      font-size: 10px;
      text-align: center;
      margin-top: 10px;
    }
  </style>
</head>
<body>
  <div class="ticket">
    <div class="text-center">
      <div class="title">${tituloTiquete}</div>
      <div class="subtitle">${this.editedItem.emisorNombreComercial || this.editedItem.emisorNombre || 'N/A'}</div>
      <div class="info">
        Correo: ${this.editedItem.emisorCorreo || '-'}<br>
        Tel: ${this.editedItem.emisorTelefono || '-'}<br>
        Cédula: ${this.strCia || '-'}
      </div>
    </div>

    <hr>
    
    ${this.editedItem.clavehacienda ? `
    <div class="clave-box">
      <div class="font-bold">COD. ELECTRONICO:</div>
      <div>${this.editedItem.consHacReal}</div>
    </div>
    <div class="clave-box">
      <div class="font-bold">CLAVE HACIENDA:</div>
      <div>${this.editedItem.clavehacienda}</div>
    </div>
    <hr>
    ` : ''}

    <div class="details">
      <p><span class="font-bold">N.º de Factura:</span> ${this.editedItem.codigoFact}</p>
      <div class="flex-row">
        <p><span class="font-bold">Fecha:</span> ${fecha}</p>
        <p><span class="font-bold">Hora:</span> ${hora}</p>
      </div>
      <p><span class="font-bold">Cliente:</span> ${this.editedItem.clienteNombre || 'CLIENTE CONTADO'}</p>
      ${this.editedItem.clienteCedula ? `
      <div class="flex-row">
        <p><span class="font-bold">Cédula:</span> ${this.editedItem.clienteCedula}</p>
        <p><span class="font-bold">Tel:</span> ${this.editedItem.clienteTelefono || '-'}</p>
      </div>
      ` : ''}
    </div>

    <hr>
    <div class="font-bold" style="font-size:13px; margin-bottom: 4px; text-transform: uppercase;">Producto</div>
    <div class="products">
      ${productosHTML}
    </div>

    <hr>
    
    <div class="totals">
      <div class="flex-row">
        <span class="font-bold">SubTotal:</span>
        <span>${this.editedItem.subtotalStr || '0.00'}</span>
      </div>
      <div class="flex-row">
        <span class="font-bold">Descuento:</span>
        <span>${this.editedItem.totalDescuentosStr || '0.00'}</span>
      </div>
      
      <hr>
      
      <div class="flex-row">
        <span class="font-bold">SubTotal neto:</span>
        <span>${this.editedItem.subtotalStr || '0.00'}</span> 
      </div>
      <div class="flex-row">
        <span class="font-bold">Impuestos:</span>
        <span>${this.editedItem.totalImpuestoStr || '0.00'}</span>
      </div>
      <div class="flex-row grand-total">
        <span>TOTAL:</span>
        <span>${this.editedItem.totalComprobanteStr || '0.00'}</span>
      </div>
    </div>

    <hr>
    
    <div class="footer">
      Autorizada mediante resolución N° MH-DGT-RES-0027-2024 del 13 de noviembre<br><br>
      <span class="font-bold" style="font-size: 14px; text-transform: uppercase;">Gracias por su compra</span>
    </div>
  </div>
</body>
</html>`;
    },

    openCash: async (me, amount, tdc) => {
      await CashService.openCash(me.strCia, me.user.id, amount, tdc)
      me.useCash(me)
    },

    useCash: async (me) => {
      me.cajaPOS = await CashService.getOpenedCash(me.strCia, me.user.id)
      if (me.cajaPOS == null) {
        me.cashOpened = false
        console.log("No opened cash")
      } else {
        me.cashOpened = true
      }
    },

    cerrarCaja: async (me) => {
      me.cierreCajaResumen = await CashService.closeCash(me.strCia, me.cajaPOS.id, me.user.id)
      me.dialogCierreCaja = true;
    },

    cerrarVentanaCierre() {
      this.dialogCierreCaja = false;
      // No seteamos cashOpened = false aquí para poder regresar al POS si la caja sigue abierta
    },

    imprimirCierreCaja() {
      const fecha = this.formatDate(new Date());
      let ticketHTML = `
      <html>
      <head>
        <title>Cierre de Caja</title>
        <style>
          body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 13px; color: #000; margin: 0; padding: 0; }
          .ticket { width: 100%; max-width: 320px; margin: 0 auto; padding: 10px; }
          .text-center { text-align: center; }
          .font-bold { font-weight: bold; }
          .title { font-size: 18px; font-weight: bold; margin-bottom: 5px; text-transform: uppercase; }
          .info { font-size: 13px; line-height: 1.3; }
          hr { border: 0; border-top: 1px dashed #000; margin: 8px 0; }
          .flex-row { display: flex; justify-content: space-between; align-items: flex-end; margin: 4px 0; }
        </style>
      </head>
      <body>
        <div class="ticket">
          <div class="text-center">
            <div class="title">REPORTE DE CIERRE</div>
            <div class="info">COMERCIO: ${this.strCia || 'N/A'}</div>
          </div>
          <hr>
          <div class="info">
            <div class="flex-row"><span class="font-bold">FECHA:</span> <span>${fecha}</span></div>
            <div class="flex-row"><span class="font-bold">USUARIO:</span> <span>${this.user.nombre}</span></div>
            <div class="flex-row"><span class="font-bold">TERMINAL:</span> <span>00001</span></div>
          </div>
          <hr>
          <div class="info">
            <div class="flex-row"><span>Fondo Apertura:</span> <span>₡${this.cierreCajaResumen.montoApertura || 0}</span></div>
            <div class="flex-row"><span>Entradas a Caja:</span> <span>₡${this.cierreCajaResumen.montoIngresos || 0}</span></div>
            <div class="flex-row"><span>Salidas de Caja:</span> <span style="color:red">₡${this.cierreCajaResumen.montoSalidas || 0}</span></div>
          </div>
          <hr>
          <div class="info">
            <div class="flex-row"><span>Ventas Efectivo:</span> <span>₡${this.cierreCajaResumen.montoEfectivo || 0}</span></div>
            <div class="flex-row"><span>Ventas Tarjeta:</span> <span>₡${this.cierreCajaResumen.montoTarjeta || 0}</span></div>
            <div class="flex-row"><span>Ventas Sinpe:</span> <span>₡${this.cierreCajaResumen.montoSinpe || 0}</span></div>
          </div>
          <hr>
          <div class="info">
            <div class="flex-row font-bold" style="font-size: 16px; margin-top: 10px;">
              <span>TOTAL EN CAJA:</span> <span>₡${this.cierreCajaResumen.montoCierreCaja || 0}</span>
            </div>
          </div>
          <hr>
          <div class="text-center info" style="margin-top: 15px;">
            <div class="font-bold">¡Excelente turno!</div>
            <div>*** CIERRE COMPLETADO ***</div>
          </div>
        </div>
      </body>
      </html>
      `;

      let iframe = document.getElementById('printFrame');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'printFrame';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(ticketHTML);
      doc.close();

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
           this.cerrarVentanaCierre();
        }, 1000);
      }, 500);
    },

    formatDate(fecha) {
      if (!fecha) return "";
      const date = new Date(fecha);
      return date.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      });
    },

    crearMovCaja: async (me) => {
      const response = await CashService.movementCash(me.strCia, me.user.id, me.cajaMovItem.monto, me.cajaPOS.id, me.cajaMovItem.tipo, me.cajaMovItem.descripcion)

      if (response == null) {
        console.log("Ocurrio un error")
      } else {
        me.dialogCajaMov = false;
        me.cajaMovItem.monto = 0;
        me.cajaMovItem.tipo = 1;
        me.cajaMovItem.descripcion = "";
      }
    },

  },
};
</script>

<style>
.cd {
  overflow: scroll;
}

.display-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.label {
  font-weight: bold;
  color: #666;
}

.value {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.v-tabs-items {
  overflow: auto;
}


/* PREMIUM MODERN POS STYLES */
:root {
  --pos-primary: #1e3a8a;
  --pos-accent: #0ea5e9;
  --pos-bg: #f8fafc;
  --pos-card-bg: rgba(255, 255, 255, 0.8);
  --pos-glass: blur(12px);
  --pos-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);
}

.renderPage {
  background: var(--pos-bg) !important;
  min-height: 100vh;
  font-family: 'Inter', sans-serif !important;
}

.theme--dark .renderPage {
  background: #0f172a !important;
}

.theme--dark .v-toolbar.pos-toolbar-theme {
  background-color: #1e293b !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
.theme--dark .v-toolbar.pos-toolbar-theme .v-toolbar__title {
  color: #fff !important;
}
.theme--dark .v-toolbar.pos-toolbar-theme .grey--text {
  color: #94a3b8 !important;
}

/*
  pos-split-container height:
  100vh - 70px (v-main padding for app-bar) - 24px (container pa-md-6 top) - 64px (POS toolbar) - 24px (container pa-md-6 bottom)
  = 100vh - 182px
  Using 186px to add a 4px safety buffer.
*/
.pos-split-container {
  height: calc(100vh - 186px) !important;
  align-items: stretch !important;
  overflow: hidden;
}

/* Left panel: table scrollable */

.pos-cart-panel .cart-table .v-data-table__wrapper {
  overflow-y: auto !important;
  max-height: calc(100vh - 260px) !important;
}

/* Right panel: flex column so actions-container fills remaining height */
.pos-checkout-panel {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
}


.premium-card {
  background: white !important;
  border-radius: 20px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease;
}
.theme--dark .premium-card {
  background: #1e293b !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.premium-card:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
}

.cart-table .v-data-table__wrapper {
  border-radius: 16px;
}

.cart-table th,
.cart-table .v-data-table__wrapper table thead tr th,
.theme--light.v-data-table .cart-table .v-data-table__wrapper table thead tr th,
.theme--light .cart-table .v-data-table__wrapper table thead tr th {
  background-color: #37474f !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.theme--dark .cart-table th,
.theme--dark .cart-table .v-data-table__wrapper table thead tr th {
  background-color: #263238 !important;
  color: #cfd8dc !important;
}

.theme--dark .cart-table td {
  color: white !important;
  font-weight: bold !important;
}

.theme--light .cart-table td {
  color: #000000 !important;
  font-weight: 900 !important;
}

/* NEW TOTAL DISPLAY - CONTRASTE ALTO */
.total-display {
  background: #f1f5f9;
  border-radius: 20px;
  padding: clamp(14px, 2.5vh, 32px) 16px;
  color: #0f172a;
  text-align: center;
  margin-bottom: 8px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(226, 232, 240, 0.8);
  /* Crece proporcionalmente con la pantalla */
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}
.theme--dark .total-display {
  background: #334155 !important; /* Gris un poco más claro que el fondo principal */
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.total-label {
  font-size: clamp(1rem, 1.8vh, 1.5rem);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.8;
  font-weight: 800;
  color: #475569;
}
.theme--dark .total-label {
  color: #94a3b8;
}

.total-amount {
  font-size: clamp(2.2rem, 7vh, 5.5rem) !important;
  font-weight: 900;
  line-height: 1.1;
  margin: clamp(4px, 1vh, 14px) 0;
  color: #0f172a;
  text-shadow: none;
  word-break: break-word;
}
.theme--dark .total-amount {
  color: #ffffff;
}

.sub-amounts {
  color: #334155;
  font-size: clamp(1rem, 2vh, 1.5rem) !important;
  padding: clamp(3px, 0.6vh, 8px) 0;
}
.theme--dark .sub-amounts {
  color: #cbd5e1;
}

/* QUICK CASH BUTTONS */
.quick-cash-container {
  gap: 8px;
}
.quick-cash-btn {
  background: rgba(34, 197, 94, 0.05) !important;
  border: 2px solid rgba(34, 197, 94, 0.3) !important;
  transition: all 0.2s ease;
  height: clamp(44px, 6vh, 72px) !important;
}
.quick-cash-btn span {
  color: #0f172a !important; /* Texto negro en modo claro */
}
.quick-cash-btn .v-icon {
  color: #22c55e !important;
}
.quick-cash-btn:hover {
  background: rgba(34, 197, 94, 0.1) !important;
  border-color: rgba(34, 197, 94, 0.6) !important;
  transform: translateY(-2px);
}
.theme--dark .quick-cash-btn {
  background: rgba(34, 197, 94, 0.1) !important;
  border: 2px solid rgba(34, 197, 94, 0.5) !important;
}
.theme--dark .quick-cash-btn span {
  color: #ffffff !important; /* Texto blanco en modo oscuro */
}
.theme--dark .quick-cash-btn:hover {
  background: rgba(34, 197, 94, 0.2) !important;
}

/* ACTION BUTTONS SOLID */
.action-btn-solid {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  transition: transform 0.2s ease;
  border-radius: 8px !important; 
}
.action-btn-solid:hover {
  transform: translateY(-2px);
}

/* DATA TABLE BUBBLE ROW EFFECT */
.cart-table.v-data-table {
  background: transparent !important;
}
.cart-table .v-data-table__wrapper > table > tbody > tr {
  transition: all 0.2s ease, background 0s !important;
}
.cart-table .v-data-table__wrapper > table > tbody > tr:hover {
  background: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  transform: scale(1.005);
  position: relative;
  z-index: 2;
}
.theme--dark .cart-table .v-data-table__wrapper > table > tbody > tr:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}
.cart-table .v-data-table__wrapper > table > tbody > tr:hover td:first-child {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.cart-table .v-data-table__wrapper > table > tbody > tr:hover td:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.cart-table .v-data-table__wrapper > table > tbody > tr > td {
  border-bottom: 1px solid rgba(148, 163, 184, 0.1) !important;
}
.cart-table .v-data-table__wrapper > table > tbody > tr:hover > td {
  border-bottom-color: transparent !important;
}

.custom-huge-btn {
  border-radius: 20px !important;
  flex: 0 0 auto !important; /* stop stretching */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.custom-huge-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.tipo-doc-switch.v-input--switch {
  transform: scale(0.8);
  transform-origin: left center;
}

.scan-input .v-input__slot {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
  padding: 0 24px !important;
  min-height: 56px !important;
}
.theme--dark .scan-input .v-input__slot {
  background: #1e293b !important;
}
.theme--dark .scan-input input {
  color: #fff !important;
}

.checkout-btn {
  border-radius: 16px !important;
  height: 64px !important;
  font-weight: 800 !important;
  font-size: 1.125rem !important;
  letter-spacing: 0.025em;
  text-transform: none !important;
}

.payment-dialog-card {
  border-radius: 32px !important;
  overflow: hidden;
}

.payment-header {
  background-color: #37474f !important;
  padding: 24px;
}

.v-btn--fab.v-btn--small {
  height: 44px;
  width: 44px;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* BOTONES PAGO / NUEVA VENTA — escalan con la pantalla */
.pos-btn-pago {
  height: clamp(52px, 7vh, 80px) !important;
  font-size: clamp(0.95rem, 1.6vh, 1.2rem) !important;
}
.pos-btn-nueva {
  height: clamp(46px, 6vh, 70px) !important;
  font-size: clamp(0.9rem, 1.4vh, 1.1rem) !important;
}

/* ACTIONS CONTAINER CONTRAST */
.actions-container {
  background: #f1f5f9;
  border-radius: 28px !important;
  border: 1px solid rgba(226, 232, 240, 1);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.03);
  /* Fill remaining height; distribute sections evenly with equal spacing around each group */
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-evenly !important;
}
.theme--dark .actions-container {
  background: #334155 !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

/* ARQUEO FÍSICO STYLES 💎📈🪄 */
.centered-input-cierre >>> input {
  text-align: center !important;
  font-weight: 800 !important;
  font-size: 1.1rem !important;
  color: #1a237e !important;
}
.theme--dark .centered-input-cierre >>> input {
  color: #c5cae9 !important;
}
.custom-closing-input >>> .v-input__slot {
  border-width: 2px !important;
}
.border-grey-lighten-2 {
  border-color: #E0E0E0 !important;
}
.border-primary-lighten-2 {
  border-color: #BBDEFB !important;
}
.shadow-24 {
  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12) !important;
}
.line-height-1 {
  line-height: 1 !important;
}
</style>
